import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';
import { useFetchData } from '../hooks/use-fetcher-new';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BaseUrl: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  FloatPercentage: { input: number; output: number; }
  NonEmptyString: { input: string; output: string; }
  PositiveInteger: { input: number; output: number; }
  URL: { input: string; output: string; }
  Void: { input: any; output: any; }
};

/** **Accept order claim with refund input** */
export type AcceptOrderClaimWithRefundInput = {
  /** **Claim identifier** */
  claimId: Scalars['ID']['input'];
  /** **Order identifier** */
  orderId: Scalars['ID']['input'];
};

/** **Accept order claim with reship input** */
export type AcceptOrderClaimWithReshipInput = {
  /** **Claim identifier** */
  claimId: Scalars['ID']['input'];
  /** **Order identifier** */
  orderId: Scalars['ID']['input'];
};

/** **Accept order claim with voucher replacement codes input** */
export type AcceptOrderClaimWithVoucherReplacementCodesInput = {
  /** **Claim identifier** */
  claimId: Scalars['ID']['input'];
  /** **Order identifier** */
  orderId: Scalars['ID']['input'];
  /** **Voucher replacement codes** */
  voucherReplacementCodes: Array<VoucherReplacementCodeInput>;
};

/** **Accept order claim with voucher replacement message input** */
export type AcceptOrderClaimWithVoucherReplacementMessageInput = {
  /** **Claim identifier** */
  claimId: Scalars['ID']['input'];
  /** **Order identifier** */
  orderId: Scalars['ID']['input'];
  /** **Voucher replacement message** */
  voucherReplacementMessage: Scalars['String']['input'];
};

/** **Rule concerning the activation date of the down payment** */
export type ActivationDateRule = {
  __typename?: 'ActivationDateRule';
  /** **The expected activation date for the down payment** */
  activationDate: Scalars['DateTime']['output'];
  /** **Indicates whether the activation date rule is met** */
  isValidated: Scalars['Boolean']['output'];
};

/** **Address** */
export type Address = {
  __typename?: 'Address';
  /** **City** */
  city: Scalars['String']['output'];
  /** **Country** */
  country: Scalars['String']['output'];
  /** **Country code** */
  countryCode: Scalars['String']['output'];
  /** **County** */
  county?: Maybe<Scalars['String']['output']>;
  /** **Letters indicating which state the address is from** */
  state?: Maybe<Scalars['String']['output']>;
  /** **Street** */
  street: Scalars['String']['output'];
  /** **Street additional** */
  streetAdditional?: Maybe<Scalars['String']['output']>;
  /** **Zip code** */
  zipCode: Scalars['String']['output'];
};

export type BasicUserInfo = {
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type BillingByVatV2 = {
  __typename?: 'BillingByVatV2';
  total_billing_ht: Scalars['Int']['output'];
  total_billing_ttc: Scalars['Int']['output'];
  total_commission_ht: Scalars['Int']['output'];
  total_commission_ttc: Scalars['Int']['output'];
  total_operation_ht: Scalars['Int']['output'];
  total_operation_ttc: Scalars['Int']['output'];
  total_vat: Scalars['Int']['output'];
  vat_rate: Scalars['String']['output'];
};

/** **Billing export** */
export type BillingExport = {
  __typename?: 'BillingExport';
  /** **File url** */
  fileUrl: Scalars['URL']['output'];
};

/** **Billing export input** */
export type BillingExportInput = {
  /** **File extension** */
  fileExtension: FileExtension;
};

export type BillingPaymentLine = {
  __typename?: 'BillingPaymentLine';
  amountVatExcludedInCents: Scalars['Int']['output'];
  amountVatInCents: Scalars['Int']['output'];
  amountVatIncludedInCents: Scalars['Int']['output'];
  invoiceId: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
};

/** **Error information of the billing edition** */
export type BillingStateError = {
  __typename?: 'BillingStateError';
  /** **Error code of this issue** */
  code: BillingStateErrorCode;
  /** **Identifiant of order | return | claim that have an issue** */
  id: Scalars['String']['output'];
};

/** **List of errors type that lock billing edition** */
export enum BillingStateErrorCode {
  /** **Claim is unfulfilled** */
  ClaimUnfulfilled = 'CLAIM_UNFULFILLED',
  /** **Order is not yet delivered** */
  OrderNotDelivered = 'ORDER_NOT_DELIVERED',
  /** **Return is not yet validated** */
  ReturnNotValidated = 'RETURN_NOT_VALIDATED'
}

/** **Information about state of billing** */
export type BillingStateV2 = {
  __typename?: 'BillingStateV2';
  /** **All claims have been fulfilled by the brand ?** */
  allClaimsFulfilled: Scalars['Boolean']['output'];
  /** **All orders have been received by the customer ?** */
  allOrdersDelivered: Scalars['Boolean']['output'];
  /** **All returns have been validated by the brand / bot auto ?** */
  allReturnsValidated: Scalars['Boolean']['output'];
  /** **Billing can be edited ?** */
  canEdit: Scalars['Boolean']['output'];
  /**
   * **Date that the billing will be accessible and editable**
   *
   * - > null if there are somes errors => see 'errors'
   */
  editableAt?: Maybe<Scalars['DateTime']['output']>;
  /** **List of errors that lock billing's edition** */
  errors: Array<BillingStateError>;
  /**
   * **Billing can be edited with errors ?**
   *
   * - > true if financial team accept to display billing to brand even though has errors
   */
  forceEdit: Scalars['Boolean']['output'];
  /** **Date that the sale will be closed** */
  saleEndsAt: Scalars['DateTime']['output'];
  /** **Sale status** */
  saleStatus: SaleStatus;
  /** **Customer withdrawal period (in days)** */
  withdrawalPeriod: Scalars['Int']['output'];
};

export type BillingV2 = {
  __typename?: 'BillingV2';
  adjustments: Array<SupplierBillingAdjustment>;
  agg_by_vat_rate: Array<BillingByVatV2>;
  down_payment?: Maybe<DownPaymentV2>;
  errors: Array<ProductSoldErrorV2>;
  has_error: Scalars['Boolean']['output'];
  is_full_paid: Scalars['Boolean']['output'];
  is_subject_to_vat: Scalars['Boolean']['output'];
  payments: Array<BillingPaymentLine>;
  total_adjustment_ht: Scalars['Int']['output'];
  total_adjustment_ttc: Scalars['Int']['output'];
  total_billing_ht: Scalars['Int']['output'];
  total_billing_ttc: Scalars['Int']['output'];
  total_commission_ht: Scalars['Int']['output'];
  total_commission_ttc: Scalars['Int']['output'];
  total_delivery_ht: Scalars['Int']['output'];
  total_delivery_ttc: Scalars['Int']['output'];
  total_eee_price_ttc: Scalars['Int']['output'];
  total_operation_ht: Scalars['Int']['output'];
  total_operation_ttc: Scalars['Int']['output'];
  total_refund_ht: Scalars['Int']['output'];
  total_refund_ttc: Scalars['Int']['output'];
  total_remaining_ht: Scalars['Int']['output'];
  total_remaining_ttc: Scalars['Int']['output'];
  total_turnover_ht: Scalars['Int']['output'];
  total_turnover_ttc: Scalars['Int']['output'];
};

export type BrandAccess = {
  __typename?: 'BrandAccess';
  brandId: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  role: Scalars['String']['output'];
  store: Store;
};

export type BrandInfo = {
  __typename?: 'BrandInfo';
  acceptContract: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nbUsers: Scalars['Int']['output'];
  store: Store;
};

export enum BrandRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

/** **The buyer is the person who has been billed for the order** */
export type Buyer = {
  __typename?: 'Buyer';
  /** **Address** */
  address: Address;
  /** **First name** */
  firstName: Scalars['String']['output'];
  /** **Full name ("first_name last_name")** */
  fullName: Scalars['String']['output'];
  /** **Last name** */
  lastName: Scalars['String']['output'];
  /** **Previous buyer if it has been updated** */
  previous?: Maybe<Buyer>;
};

/** Claim */
export type Claim = {
  __typename?: 'Claim';
  /** Action chosen by the supplier when the claim has been accepted */
  acceptedAction?: Maybe<ClaimSellerAction>;
  /** Date when the claim has been accepted */
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * **Message written by the seller when it accept the claim**
   * @deprecated Use `acceptedNote` instead
   */
  acceptedMessage?: Maybe<Scalars['String']['output']>;
  /** Note written by the supplier when the claim has been accepted */
  acceptedNote?: Maybe<Scalars['String']['output']>;
  /**
   * **Action chose by the seller when it has accepted the claim**
   * @deprecated Use `acceptedAction` instead
   */
  actionFromSeller?: Maybe<ClaimSellerAction>;
  /** Date when the claim has been canceled */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date of the creation */
  createdAt: Scalars['DateTime']['output'];
  /**
   * **Message written by the seller when it decline the claim**
   * @deprecated Never been used
   */
  declinedMessage?: Maybe<Scalars['String']['output']>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Id */
  id: Scalars['ID']['output'];
  /**
   * **Is accepted ?**
   * @deprecated Use `acceptedAt` instead
   */
  isAccepted: Scalars['Boolean']['output'];
  /**
   * **Is declined ?**
   * @deprecated Never been used
   */
  isDeclined: Scalars['Boolean']['output'];
  /** Whether the claim has been opened by a bot */
  isOpenedByBot: Scalars['Boolean']['output'];
  /** Items */
  items: Array<Item>;
  /**
   * **Message written by the support team to the seller**
   * @deprecated Use `description` instead
   */
  messageFromSupport?: Maybe<Scalars['String']['output']>;
  /**
   * **Other reason label written by the support team when the reason is "OTHER"**
   * @deprecated Never been used
   */
  otherReasonLabel?: Maybe<Scalars['String']['output']>;
  /** Preferred solution */
  preferredSolution: ClaimPreferredSolution;
  /** Proof URLs */
  proofUrls: Array<Scalars['String']['output']>;
  /** Reason */
  reason: ClaimReason;
  /** Reship action error reasons if the action is not available */
  reshipActionErrorReasons: Array<ClaimReshipActionErrorReason>;
  /** Support ticket id */
  supportTicketId?: Maybe<Scalars['ID']['output']>;
  /** Sworn statement URLs */
  swornStatementUrls: Array<Scalars['String']['output']>;
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
};

/** Claim preferred solution */
export enum ClaimPreferredSolution {
  /** No preference */
  NoPreference = 'NoPreference',
  /** Refund */
  Refund = 'Refund',
  /** Reship */
  Reship = 'Reship'
}

/** **Claim Reason** */
export enum ClaimReason {
  /** **The customer has received the parcel but is damaged** */
  DeliveredButDamaged = 'DELIVERED_BUT_DAMAGED',
  /** **The customer has received the parcel but is incomplete** */
  DeliveredButIncomplete = 'DELIVERED_BUT_INCOMPLETE',
  /** **The customer has received the parcel but is wrong (wrong or missing items)** */
  DeliveredButWrong = 'DELIVERED_BUT_WRONG',
  /** **The customer has received a digital coupon code but is not working** */
  DigitalCouponCodeNotWorking = 'DIGITAL_COUPON_CODE_NOT_WORKING',
  /** **The customer has not received the parcel and has been returned to the sender** */
  NotDeliveredAndReturnedToSender = 'NOT_DELIVERED_AND_RETURNED_TO_SENDER',
  /** **The customer has not received the parcel and the tracking is blocked** */
  NotDeliveredAndTrackingBlocked = 'NOT_DELIVERED_AND_TRACKING_BLOCKED',
  /** **The customer has not received the parcel and the tracking is delivered** */
  NotDeliveredAndTrackingDelivered = 'NOT_DELIVERED_AND_TRACKING_DELIVERED',
  /** **Other** */
  Other = 'OTHER'
}

/** **Claim reship action error reason** */
export enum ClaimReshipActionErrorReason {
  /** **There is no items to reship** */
  NoItems = 'NO_ITEMS',
  /** **The order has already been reshipped** */
  OrderAlreadyReshipped = 'ORDER_ALREADY_RESHIPPED',
  /** **The order is cancelled** */
  OrderCancelled = 'ORDER_CANCELLED',
  /** **Some of the items to reship are digital** */
  SomeItemsDigital = 'SOME_ITEMS_DIGITAL'
}

/** **Claim seller action (action chose by the seller when it has accepted the claim)** */
export enum ClaimSellerAction {
  /** **The seller has directy handled the claim with the customer** */
  DirectlyHandledWithTheCustomer = 'DIRECTLY_HANDLED_WITH_THE_CUSTOMER',
  /** **The seller decided to resend a new digital coupon code for the items** */
  ItemsDigitalCouponCodesResent = 'ITEMS_DIGITAL_COUPON_CODES_RESENT',
  /** **The seller decided to refund the items** */
  ItemsRefunded = 'ITEMS_REFUNDED',
  /** **The seller decided to reship the items** */
  ItemsReshipped = 'ITEMS_RESHIPPED'
}

/** **Courier** */
export type Courier = {
  __typename?: 'Courier';
  /** **Alternative name of the courier** */
  alternativeName?: Maybe<Scalars['String']['output']>;
  /** **Contact phone number of the courier** */
  contactPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** **Default language of the courier** */
  defaultLanguage: Scalars['String']['output'];
  /** **Logo url of the courier** */
  logoUrl: Scalars['String']['output'];
  /** **Name of the courier** */
  name: Scalars['String']['output'];
  /** **Slug of the courier** */
  slug: Scalars['String']['output'];
  /** **Supported countries of the courier** */
  supportedCountries: Array<Scalars['String']['output']>;
  /** **Supported languages of the courier** */
  supportedLanguages: Array<Scalars['String']['output']>;
  /** **Web url of the courier** */
  webUrl?: Maybe<Scalars['String']['output']>;
};

/** **Create order parcel input** */
export type CreateOrderParcelInput = {
  /** **Order id** */
  orderId: Scalars['ID']['input'];
  /** **Tracking info** */
  trackingInfo: TrackingInfoInput;
};

/** **Create supplier billing adjustment input** */
export type CreateSupplierBillingAdjustmentInput = {
  amountVatExcludedInCents?: InputMaybe<Scalars['PositiveInteger']['input']>;
  chargedTo: SupplierBillingAdjustmentChargeTo;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<Scalars['String']['input']>>;
  saleId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['FloatPercentage']['input']>;
};

/** **Currency ISO code** */
export enum CurrencyIso {
  /** **Euro** */
  Eur = 'eur',
  /** **US Dollar** */
  Usd = 'usd'
}

/** **Represents a range of date and time when the parcel is expected to arrive at the customer's location** */
export type DeliveryDateRange = {
  __typename?: 'DeliveryDateRange';
  /** **The creation date** */
  createdAt: Scalars['DateTime']['output'];
  /** **The latest delivery date and time when the parcel is expected to arrive at the customer's location** */
  end: Scalars['Date']['output'];
  /** **The earliest delivery date and time when the parcel is expected to arrive at the customer's location** */
  start: Scalars['Date']['output'];
};

/** **Detect couriers input** */
export type DetectCouriersInput = {
  /** **Identifier of the order** */
  orderId: Scalars['ID']['input'];
  /** **Tracking number** */
  trackingNumber: Scalars['String']['input'];
};

export type DownPaymentClassic = {
  __typename?: 'DownPaymentClassic';
  /** **Financial detail** */
  financialDetail: FinancialBilling;
  /** **Predefined value for the down payment** */
  preset: DownPaymentPreset;
  /** **Applicable down payment rate (as a percentage)** */
  rate: Scalars['Int']['output'];
  /** **Set of rules governing the down payment thresholds and validations** */
  rules: Array<DownPaymentRules>;
};

export type DownPaymentExceptional = {
  __typename?: 'DownPaymentExceptional';
  /** **Predefined value for the down payment** */
  preset: DownPaymentPreset;
};

/** **Enum representing predefined down payment values** */
export enum DownPaymentPreset {
  Classic = 'CLASSIC',
  Exceptional = 'EXCEPTIONAL'
}

export type DownPaymentRules = ActivationDateRule | FulfilledOrderPercentageRule | MinimumAmountInCentsRule;

export type DownPaymentV2 = DownPaymentClassic | DownPaymentExceptional;

/** **File extension** */
export enum FileExtension {
  /** **CSV** */
  Csv = 'CSV',
  /** **XLSX (excel)** */
  Xlsx = 'XLSX'
}

export type FinancialBilling = {
  __typename?: 'FinancialBilling';
  agg_by_vat_rate: Array<BillingByVatV2>;
  total_billing_ht: Scalars['Int']['output'];
  total_billing_ttc: Scalars['Int']['output'];
  total_commission_ht: Scalars['Int']['output'];
  total_commission_ttc: Scalars['Int']['output'];
  total_delivery_ht: Scalars['Int']['output'];
  total_delivery_ttc: Scalars['Int']['output'];
  total_operation_ht: Scalars['Int']['output'];
  total_operation_ttc: Scalars['Int']['output'];
  total_refund_ht: Scalars['Int']['output'];
  total_refund_ttc: Scalars['Int']['output'];
  total_remaining_ht: Scalars['Int']['output'];
  total_remaining_ttc: Scalars['Int']['output'];
  total_turnover_ht: Scalars['Int']['output'];
  total_turnover_ttc: Scalars['Int']['output'];
};

/** **Rule concerning the percentage of order fulfillment** */
export type FulfilledOrderPercentageRule = {
  __typename?: 'FulfilledOrderPercentageRule';
  /** **The current percentage of the order fulfillment achieved** */
  currentValue: Scalars['Int']['output'];
  /** **Indicates whether the order fulfillment percentage rule is met** */
  isValidated: Scalars['Boolean']['output'];
  /** **The required percentage of order fulfillment to meet the condition** */
  targetValue: Scalars['Int']['output'];
};

/** **Invoice for customs info** */
export type GenerateInvoiceCustoms = {
  __typename?: 'GenerateInvoiceCustoms';
  /** **Url of invoice pdf** */
  url: Scalars['String']['output'];
};

/** **Purchase order info** */
export type GeneratePurchaseOrder = {
  __typename?: 'GeneratePurchaseOrder';
  /** **Url of purchase order pdf** */
  url: Scalars['String']['output'];
};

/** **Group order parcel input** */
export type GroupOrderParcelInput = {
  /** **Order id** */
  orderId: Scalars['ID']['input'];
  /** **Order ids excluded** */
  orderIdsExcluded?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** **Tracking info** */
  trackingInfo: TrackingInfoInput;
};

/** **Invoice** */
export type Invoice = {
  __typename?: 'Invoice';
  /** **Creation date of the invoice** */
  createdAt: Scalars['DateTime']['output'];
  /** **File name of the invoice file** */
  fileName: Scalars['String']['output'];
  /** **Url of the invoice file** */
  fileUrl: Scalars['URL']['output'];
  /** **Identifier of the invoice** */
  id: Scalars['ID']['output'];
  /** **Status of the invoice** */
  status: InvoiceStatus;
  /** **Type of the invoice** */
  type: InvoiceType;
};

/** **Invoice status** */
export enum InvoiceStatus {
  BotError = 'bot_error',
  BotProcessing = 'bot_processing',
  Paid = 'paid',
  Received = 'received',
  Rejected = 'rejected',
  ToBePaid = 'to_be_paid',
  Validated = 'validated'
}

/** **Invoice types** */
export enum InvoiceType {
  CreditNote = 'credit_note',
  DownPayment = 'down_payment',
  FinalBalance = 'final_balance',
  Invoice = 'invoice',
  Proforma = 'proforma',
  StatementOfAccount = 'statement_of_account'
}

/** **Item** */
export type Item = {
  __typename?: 'Item';
  /** **Digital coupon code** */
  digitalCouponCode?: Maybe<Scalars['String']['output']>;
  /** **GTIN** */
  gtin?: Maybe<Scalars['String']['output']>;
  /** **ID** */
  id: Scalars['ID']['output'];
  /** **Image URL** */
  imageUrl: Scalars['String']['output'];
  /** **Is cancellable ?** */
  isCancellable: Scalars['Boolean']['output'];
  /** **Is cancelled ?** */
  isCancelled: Scalars['Boolean']['output'];
  /** **Is digital ?** */
  isDigital: Scalars['Boolean']['output'];
  /** **Is offered ?** */
  isOffered: Scalars['Boolean']['output'];
  /** **Is reshipped ?** */
  isReshipped: Scalars['Boolean']['output'];
  /** **A return has been generated for this item ?** */
  isReturnGenerated: Scalars['Boolean']['output'];
  /** **A return has been validated for this item ?** */
  isReturnValidated: Scalars['Boolean']['output'];
  /** **Is returnable ?** */
  isReturnable: Scalars['Boolean']['output'];
  /** **Name** */
  name: Scalars['String']['output'];
  /** **New digital coupon code** */
  newDigitalCouponCode?: Maybe<Scalars['String']['output']>;
  /** **Price bought by Choose** */
  priceBoughtByChoose: Price;
  /** **Price sold by Choose to the customer (in cents)** */
  priceSold: Price;
  /** **Product ID** */
  productId: Scalars['String']['output'];
  /** **Product variant ID** */
  productVariantId: Scalars['String']['output'];
  /** **Refund summary** */
  refundSummary: OrderLineRefundSummary;
  /** **Return reason code** */
  returnReasonCode?: Maybe<ItemReturnReasonCode>;
  /** **Return sub reason code** */
  returnSubReasonCode?: Maybe<ItemReturnSubReasonCode>;
  /** **Notifications sent to the customer about the item** */
  sentNotifications: Array<ItemSentNotification>;
  /** **Size** */
  size?: Maybe<Scalars['String']['output']>;
  /** **SKU** */
  sku?: Maybe<Scalars['String']['output']>;
  /** **Voucher expiration date if the item is digital** */
  voucherExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** **Voucher marked as used date if the item is digital** */
  voucherMarkedAsUsedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** **Item return reason code** */
export enum ItemReturnReasonCode {
  /** **Better price** */
  BetterPrice = 'BETTER_PRICE',
  /** **Claim** */
  Claim = 'CLAIM',
  /**
   * **Damaged product**
   * @deprecated not sent by app anymore
   */
  DamagedProduct = 'DAMAGED_PRODUCT',
  /**
   * **Damaged shipping**
   * @deprecated not sent by app anymore
   */
  DamagedShipping = 'DAMAGED_SHIPPING',
  /** **Delay** */
  Delay = 'DELAY',
  /** **Description** */
  Description = 'DESCRIPTION',
  /** **Other** */
  Other = 'OTHER',
  /** **Picture** */
  Picture = 'PICTURE',
  /** **Quality** */
  Quality = 'QUALITY',
  /** **Size** */
  Size = 'SIZE',
  /**
   * **Wrong article**
   * @deprecated not sent by app anymore
   */
  WrongArticle = 'WRONG_ARTICLE'
}

/** **Item return sub reason code** */
export enum ItemReturnSubReasonCode {
  /** **bad shape** */
  BadShape = 'BAD_SHAPE',
  /** **multi size bought** */
  MultiSize = 'MULTI_SIZE',
  /** **Other** */
  Other = 'OTHER',
  /** **too large** */
  TooLarge = 'TOO_LARGE',
  /** **too long** */
  TooLong = 'TOO_LONG',
  /** **too short** */
  TooShort = 'TOO_SHORT',
  /** **too tight** */
  TooTight = 'TOO_TIGHT'
}

/** **Item sent notification** */
export enum ItemSentNotification {
  /** **Voucher expires in 7 days** */
  VoucherExpiresIn_7Days = 'VOUCHER_EXPIRES_IN_7_DAYS',
  /** **Voucher expires in 30 days** */
  VoucherExpiresIn_30Days = 'VOUCHER_EXPIRES_IN_30_DAYS'
}

/** **Join order return label for claim input** */
export type JoinOrderReturnLabelForClaimInput = {
  /** **Claim identifier** */
  claimId: Scalars['ID']['input'];
  /** **Item identifiers** */
  itemIds: Array<Scalars['ID']['input']>;
  /** **Label file identifier** */
  labelFileId: Scalars['ID']['input'];
  /** **Order identifier** */
  orderId: Scalars['ID']['input'];
  /** **Carrier slug** */
  trackingCarrierSlug: Scalars['String']['input'];
  /** **Tracking number** */
  trackingNumber: Scalars['String']['input'];
};

/** **Logistician** */
export enum Logistician {
  /** **Bigblue** */
  Bigblue = 'BIGBLUE',
  /** **Boxtal** */
  Boxtal = 'BOXTAL',
  /** **Coliship** */
  Coliship = 'COLISHIP',
  /** **Cubyn** */
  Cubyn = 'CUBYN',
  /** **Generic all items on same row** */
  GenericColumn = 'GENERIC_COLUMN',
  /** **Generic by item row** */
  GenericRow = 'GENERIC_ROW',
  /** **Sendcloud** */
  Sendcloud = 'SENDCLOUD',
  /** **Shipping bo** */
  Shippingbo = 'SHIPPINGBO',
  /** **STOCKAZ** */
  Stockaz = 'STOCKAZ',
  /** **Transporterapp** */
  Transporterapp = 'TRANSPORTERAPP'
}

export type Member = {
  __typename?: 'Member';
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  picture: Scalars['String']['output'];
  role: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** **Rule concerning the minimum amount required in cents** */
export type MinimumAmountInCentsRule = {
  __typename?: 'MinimumAmountInCentsRule';
  /** **The current down payment amount in cents** */
  currentValue: Scalars['Int']['output'];
  /** **Indicates whether the minimum amount rule is met** */
  isValidated: Scalars['Boolean']['output'];
  /** **The minimum amount that the down payment must meet (in cents)** */
  targetValue: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** **Accepts an order claim with refund** */
  acceptOrderClaimWithRefund?: Maybe<Scalars['Void']['output']>;
  /** **Accepts an order claim with reship** */
  acceptOrderClaimWithReship?: Maybe<Scalars['Void']['output']>;
  /** **Accepts an order claim with voucher replacement codes** */
  acceptOrderClaimWithVoucherReplacementCodes?: Maybe<Scalars['Void']['output']>;
  /** **Accepts an order claim with voucher replacement message** */
  acceptOrderClaimWithVoucherReplacementMessage?: Maybe<Scalars['Void']['output']>;
  changePassword?: Maybe<Scalars['String']['output']>;
  /** **Creates an order parcel with the tracking info** */
  createOrderParcel?: Maybe<Scalars['Void']['output']>;
  createPasswordConnection?: Maybe<Scalars['String']['output']>;
  /** **Create new supplier billing adjustment** */
  createSupplierBillingAdjustment?: Maybe<Scalars['Void']['output']>;
  /** **Create new  note** */
  createSupplierBillingAdjustmentNote?: Maybe<Scalars['Void']['output']>;
  /** **Delete supplier billing adjustment** */
  deleteSupplierBillingAdjustment?: Maybe<Scalars['Void']['output']>;
  /** **Delete note** */
  deleteSupplierBillingAdjustmentNote?: Maybe<Scalars['Void']['output']>;
  detachBrandUser?: Maybe<Scalars['String']['output']>;
  editBasicUserInfo?: Maybe<Scalars['String']['output']>;
  /** **Generate Invoice for customs** */
  generateInvoiceCustoms: GenerateInvoiceCustoms;
  /** **Generates an url to upload an invoice for a sale** */
  generateInvoiceUploadUrl: Upload;
  generateProfilePictureUploadUrl: Upload;
  /** **Generate purchase order** */
  generatePurchaseOrder: GeneratePurchaseOrder;
  /** **Generates an url to upload document linked to an supplier billing adjustment** */
  generateSupplierBillingAdjusmentDocumentUploadUrl: Upload;
  /** **Groups the order parcel and the related order parcels with the tracking info** */
  groupOrderParcel?: Maybe<Scalars['Void']['output']>;
  joinBrand?: Maybe<Scalars['String']['output']>;
  /** **Join an order return label for a claim** */
  joinOrderReturnLabelForClaim?: Maybe<Scalars['Void']['output']>;
  postRegister?: Maybe<PostRegisterResult>;
  /** **Set stock quantity** */
  setStock?: Maybe<SetStockErrorCode>;
  /** **Set brand role to user** */
  setUserRole?: Maybe<Scalars['Void']['output']>;
  /** **Submits a down payment invoice for a sale to be paid by Choose** */
  submitDownPayment?: Maybe<Scalars['Void']['output']>;
  /** **Submits an invoice for a sale to be paid by Choose** */
  submitInvoice?: Maybe<Scalars['Void']['output']>;
  /** **Swaps the order parcel and the related order parcels with the tracking info** */
  swapOrderParcel?: Maybe<Scalars['Void']['output']>;
  updateInviteCode: Scalars['String']['output'];
  /** **Updates the order parcel and the related order parcels with the tracking info** */
  updateOrderParcel?: Maybe<Scalars['Void']['output']>;
  updateProfilePicture?: Maybe<Scalars['Void']['output']>;
  /** **Update supplier billing adjustment** */
  updateSupplierBillingAdjustment?: Maybe<Scalars['Void']['output']>;
  /** **Update note content** */
  updateSupplierBillingAdjustmentNote?: Maybe<Scalars['Void']['output']>;
  updateUserLanguage?: Maybe<Scalars['String']['output']>;
  /** **Validate supplier billing adjustment** */
  validateSupplierBillingAdjustment?: Maybe<Scalars['Void']['output']>;
};


export type MutationAcceptOrderClaimWithRefundArgs = {
  input: AcceptOrderClaimWithRefundInput;
};


export type MutationAcceptOrderClaimWithReshipArgs = {
  input: AcceptOrderClaimWithReshipInput;
};


export type MutationAcceptOrderClaimWithVoucherReplacementCodesArgs = {
  input: AcceptOrderClaimWithVoucherReplacementCodesInput;
};


export type MutationAcceptOrderClaimWithVoucherReplacementMessageArgs = {
  input: AcceptOrderClaimWithVoucherReplacementMessageInput;
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
};


export type MutationCreateOrderParcelArgs = {
  input: CreateOrderParcelInput;
};


export type MutationCreatePasswordConnectionArgs = {
  userInfo: UserPasswordConnection;
};


export type MutationCreateSupplierBillingAdjustmentArgs = {
  input: CreateSupplierBillingAdjustmentInput;
};


export type MutationCreateSupplierBillingAdjustmentNoteArgs = {
  content: Scalars['String']['input'];
  supplierBillingAdjustmentId: Scalars['ID']['input'];
};


export type MutationDeleteSupplierBillingAdjustmentArgs = {
  supplierBillingAdjustmentId: Scalars['ID']['input'];
};


export type MutationDeleteSupplierBillingAdjustmentNoteArgs = {
  supplierBillingAdjustmentNoteId: Scalars['ID']['input'];
};


export type MutationDetachBrandUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationEditBasicUserInfoArgs = {
  basicUserInfo: BasicUserInfo;
};


export type MutationGenerateInvoiceCustomsArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationGenerateInvoiceUploadUrlArgs = {
  saleId: Scalars['ID']['input'];
  upload: UploadInput;
};


export type MutationGenerateProfilePictureUploadUrlArgs = {
  upload: UploadInput;
};


export type MutationGeneratePurchaseOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationGenerateSupplierBillingAdjusmentDocumentUploadUrlArgs = {
  saleId: Scalars['ID']['input'];
  upload: UploadInput;
};


export type MutationGroupOrderParcelArgs = {
  input: GroupOrderParcelInput;
};


export type MutationJoinBrandArgs = {
  brandId: Scalars['String']['input'];
  inviteCode: Scalars['String']['input'];
};


export type MutationJoinOrderReturnLabelForClaimArgs = {
  input: JoinOrderReturnLabelForClaimInput;
};


export type MutationPostRegisterArgs = {
  config: PostRegisterConfig;
};


export type MutationSetStockArgs = {
  input: SetStockInput;
};


export type MutationSetUserRoleArgs = {
  role: BrandRole;
  userId: Scalars['ID']['input'];
};


export type MutationSubmitDownPaymentArgs = {
  input: SubmitDownPaymentInput;
  saleId: Scalars['ID']['input'];
};


export type MutationSubmitInvoiceArgs = {
  input: SubmitInvoiceInput;
  saleId: Scalars['ID']['input'];
};


export type MutationSwapOrderParcelArgs = {
  input: SwapOrderParcelInput;
};


export type MutationUpdateOrderParcelArgs = {
  input: UpdateOrderParcelInput;
};


export type MutationUpdateProfilePictureArgs = {
  url: Scalars['BaseUrl']['input'];
};


export type MutationUpdateSupplierBillingAdjustmentArgs = {
  input: UpdateSupplierBillingAdjustmentInput;
};


export type MutationUpdateSupplierBillingAdjustmentNoteArgs = {
  content: Scalars['String']['input'];
  supplierBillingAdjustmentNoteId: Scalars['ID']['input'];
};


export type MutationUpdateUserLanguageArgs = {
  preferredLanguage: Scalars['String']['input'];
};


export type MutationValidateSupplierBillingAdjustmentArgs = {
  supplierBillingAdjustmentId: Scalars['ID']['input'];
};

/** **Operation type** */
export enum OperationType {
  /** **Choose with StockAZ clears its stock ** */
  Clearance = 'CLEARANCE',
  /** **The seller sell its products and ship on its own** */
  DropShipping = 'DROP_SHIPPING',
  /** **Choose has ordered the products before the operation and ship on its own** */
  FirmPurchase = 'FIRM_PURCHASE',
  /** **Choose order the products sold after the operation and ship it on its own** */
  PostOperationPurchase = 'POST_OPERATION_PURCHASE',
  /** **The reseller sell products from another seller => Not used anymore** */
  Reseller = 'RESELLER'
}

/** **Order** */
export type Order = {
  __typename?: 'Order';
  /** **Billing ID** */
  billingId: Scalars['ID']['output'];
  /** **The buyer is the person who has been billed for the order** */
  buyer: Buyer;
  /** **Claims** */
  claims: Array<Claim>;
  /** **Date of the creation** */
  createdAt: Scalars['DateTime']['output'];
  /** **Customer ID** */
  customerId: Scalars['ID']['output'];
  /** **Has been exported by the seller ?  (using a CSV from the dashboard in order to not process it twice)** */
  hasBeenExported: Scalars['Boolean']['output'];
  /** **Has seller error ?** */
  hasSellerError: Scalars['Boolean']['output'];
  /** **Has synchronization error ?** */
  hasSynchronizationError: Scalars['Boolean']['output'];
  /** **ID** */
  id: Scalars['ID']['output'];
  /** **Initial order if this is a reship order** */
  initialOrder?: Maybe<Order>;
  /** **ID of the initial order if this is a reship order** */
  initialOrderId?: Maybe<Scalars['ID']['output']>;
  /** **Integration** */
  integration: OrderIntegration;
  /** **Is cancelled ?** */
  isCancelled: Scalars['Boolean']['output'];
  /** **Does the order include only digital items ?** */
  isFullDigital: Scalars['Boolean']['output'];
  /** **Is shipping estimated time exceeded ?** */
  isShippingEstimatedTimeExceeded: Scalars['Boolean']['output'];
  /** **Items ordered by the customer** */
  items: Array<Item>;
  /** **Lines refunds** */
  linesRefunds: Array<OrderLineRefund>;
  /** **Operation type** */
  operationType: OperationType;
  /** **Parcels** */
  parcels: Array<Parcel>;
  /** **Payment infos** */
  payment: OrderPayment;
  /** **Rating** */
  rating?: Maybe<OrderRating>;
  /** **The recipient is the person who will receive the order** */
  recipient: Recipient;
  /** **Reship order if this is an initial order reshipped** */
  reshipOrder?: Maybe<Order>;
  /** **ID of the reship order if this is an initial order reshipped** */
  reshipOrderId?: Maybe<Scalars['ID']['output']>;
  /** **Returns** */
  returns: Array<Return>;
  /** **Sale ID** */
  saleId: Scalars['ID']['output'];
  /** **Seller ID** */
  sellerId: Scalars['ID']['output'];
  /** **Shipping infos** */
  shipping: OrderShipping;
  /** **Split action error reasons if the action is not available** */
  splitActionErrorReasons: Array<OrderSplitActionErrorReason>;
  /** **Tags** */
  tags: OrderTags;
  /** **Total price sold (items) by Choose to the customer (in cents)** */
  totalPriceSold: Price;
};

/** **Order integration** */
export type OrderIntegration = {
  __typename?: 'OrderIntegration';
  /** **Error message from the integration (Shopify, StockAZ)** */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** **ID of the order from the integration (Shopify, StockAZ)** */
  orderId?: Maybe<Scalars['ID']['output']>;
  /** **Shopify integration** */
  shopify?: Maybe<ShopifyOrderIntegration>;
};

/** **Order line refund** */
export type OrderLineRefund = {
  __typename?: 'OrderLineRefund';
  /** **Amount in cents of the refund** */
  amountInCents: Scalars['PositiveInteger']['output'];
  /** **Cover party that has covered the refund** */
  coveredBy: OrderLineRefundCover;
  /** **Creation date of the refund** */
  createdAt: Scalars['DateTime']['output'];
  /** **Identifier of the refund** */
  id: Scalars['ID']['output'];
  /** **Internal note associated to the refund** */
  internalNote?: Maybe<Scalars['String']['output']>;
  /** **Identifier of the line (item id for "ITEM" and order id for "SHIPPING" and "LEGACY")** */
  lineId: Scalars['ID']['output'];
  /** **Line type ("ITEM" or "SHIPPING")** */
  lineType: OrderLineType;
  /** **Identifier of the plan (refunds made at the same time have the same plan id)** */
  planId: Scalars['ID']['output'];
  /** **Reason of the refund** */
  reason: OrderLineRefundReason;
};

/** **Order line refund cover** */
export enum OrderLineRefundCover {
  /** **Choose has covered the refund** */
  Choose = 'CHOOSE',
  /** **The supplier has covered the refund** */
  Supplier = 'SUPPLIER'
}

/** **Order line refund reason** */
export enum OrderLineRefundReason {
  /** **A claim has been accepted** */
  ClaimAccepted = 'CLAIM_ACCEPTED',
  /** **A claim has been accepted because the parcel has not been delivered and has been returned to the sender** */
  ClaimAcceptedNotDeliveredAndReturnedToSender = 'CLAIM_ACCEPTED_NOT_DELIVERED_AND_RETURNED_TO_SENDER',
  /** **A refund has been done directly** */
  Direct = 'DIRECT',
  /** **A refund has been done directly because a claim has the deadline exceeded** */
  DirectClaimDeadlineExceeded = 'DIRECT_CLAIM_DEADLINE_EXCEEDED',
  /** **A refund has been done directly because a claim has been refused** */
  DirectClaimRefused = 'DIRECT_CLAIM_REFUSED',
  /** **A refund has been done directly to make a commercial gesture** */
  DirectCommercialGesture = 'DIRECT_COMMERCIAL_GESTURE',
  /** **A refund has been done directly because an item has a wrong image** */
  DirectItemWrongImage = 'DIRECT_ITEM_WRONG_IMAGE',
  /** **A refund has been done directly because an item has a wrong price** */
  DirectItemWrongPrice = 'DIRECT_ITEM_WRONG_PRICE',
  /** **A refund has been done because the brand didn't accept to refund client after an issue during the 2years of product guarantee** */
  DirectLegalConformityGuarantee = 'DIRECT_LEGAL_CONFORMITY_GUARANTEE',
  /** **A refund has been done directly because a return has the deadline exceeded** */
  DirectReturnDeadlineExceeded = 'DIRECT_RETURN_DEADLINE_EXCEEDED',
  /** **A refund has been done directly because a return has been locked** */
  DirectReturnLocked = 'DIRECT_RETURN_LOCKED',
  /** **A refund has been done directly because a return has been refused** */
  DirectReturnRefused = 'DIRECT_RETURN_REFUSED',
  /** **An item has been canceled** */
  ItemCanceled = 'ITEM_CANCELED',
  /** **An item has been canceled because of out of stock** */
  ItemCanceledOutOfStock = 'ITEM_CANCELED_OUT_OF_STOCK',
  /** **An order has been canceled** */
  OrderCanceled = 'ORDER_CANCELED',
  /** **A return has been accepted** */
  ReturnAccepted = 'RETURN_ACCEPTED',
  /** **An unknown reason (legacy)** */
  Unknown = 'UNKNOWN'
}

/** **Order line refund summary** */
export type OrderLineRefundSummary = {
  __typename?: 'OrderLineRefundSummary';
  /**
   * **Is refundable ?**
   *
   * Is not offered and not removed and has a price greater than 0
   */
  isRefundable: Scalars['Boolean']['output'];
  /**
   * **Is totally refunded ?**
   *
   * Has at least one refund and the refunded amount is equal to the price
   */
  isTotallyRefunded: Scalars['Boolean']['output'];
  /** **Refunded amount of the price in cents** */
  refundedAmountInCents: Scalars['PositiveInteger']['output'];
  /**
   * **Refunded amount of the price in percentage**
   *
   * Is between `0` and `100`
   */
  refundedAmountInPercentage: Scalars['FloatPercentage']['output'];
  /**
   * **Refunded amount of the price in percentage covered by Choose**
   *
   * Is between `0` and `100`
   */
  refundedAmountInPercentageCoveredByChoose: Scalars['FloatPercentage']['output'];
  /**
   * **Refunded amount of the price in percentage covered by the supplier**
   *
   * Is between `0` and `100`
   */
  refundedAmountInPercentageCoveredBySupplier: Scalars['FloatPercentage']['output'];
  /** **Remaining to refund amount of the price in cents** */
  remainingToRefundAmountInCents: Scalars['PositiveInteger']['output'];
  /**
   * **Remaining to refund amount of the price in percentage**
   *
   * Is between `0` and `100`
   */
  remainingToRefundAmountInPercentage: Scalars['FloatPercentage']['output'];
};

/** **Order line type** */
export enum OrderLineType {
  /** **Item** */
  Item = 'ITEM',
  /** **Legacy (not associated to an item or a shipping)** */
  Legacy = 'LEGACY',
  /** **Shipping** */
  Shipping = 'SHIPPING'
}

/** **Order payment** */
export type OrderPayment = {
  __typename?: 'OrderPayment';
  /** **Processor used for the payment** */
  processor: PaymentProcessor;
  /** **Processor detailed (eg: "stripe (ios Apple Pay)")** */
  processorDetailed: Scalars['String']['output'];
  /** **Processor transaction id** */
  processorTransactionId: Scalars['String']['output'];
  /** **Url of the transaction in the processor dashboard** */
  processorTransactionUrl: Scalars['String']['output'];
  /** **Sub processor used for the payment** */
  subProcessor?: Maybe<PaymentSubProcessor>;
  /** **Currency used for the payment transaction** */
  transactionCurrency: CurrencyIso;
};

/** **Order rating** */
export type OrderRating = {
  __typename?: 'OrderRating';
  /** **Message** */
  message?: Maybe<Scalars['String']['output']>;
  /** **Rate (between 1 and 5)** */
  rate: Scalars['Int']['output'];
};

/** **Order return label upload URL input** */
export type OrderReturnLabelUploadUrlInput = {
  /** **Order identifier** */
  orderId: Scalars['ID']['input'];
};

/** **Order shipping** */
export type OrderShipping = {
  __typename?: 'OrderShipping';
  /** **Delivery date range history (ordered by createdAt desc)** */
  deliveryDateRangeHistory: Array<DeliveryDateRange>;
  /** **Estimated time in days** */
  estimatedTime: Scalars['Int']['output'];
  /** **Fees (in cents)** */
  fees: Scalars['Int']['output'];
  /** **Fees sold by Choose to the customer (in cents)** */
  feesSold: Scalars['Int']['output'];
  /** **Pickup point** */
  pickupPoint?: Maybe<PickupPoint>;
  /** **Policy ID** */
  policyId?: Maybe<Scalars['ID']['output']>;
  /** **Refund summary** */
  refundSummary: OrderLineRefundSummary;
};

/** **Order split action error reason** */
export enum OrderSplitActionErrorReason {
  /** **The order has all the items digital** */
  AllItemsDigital = 'ALL_ITEMS_DIGITAL',
  /** **The order is cancelled** */
  OrderCancelled = 'ORDER_CANCELLED',
  /** **The order has been reshipped** */
  OrderReshipped = 'ORDER_RESHIPPED',
  /** **The order has some claims pending** */
  SomeClaimsPending = 'SOME_CLAIMS_PENDING',
  /** **The order has some refunds** */
  SomeRefunds = 'SOME_REFUNDS',
  /** **The order has some returns** */
  SomeReturns = 'SOME_RETURNS',
  /**
   * **The order has some return parcels**
   * @deprecated Use `SOME_RETURNS` instead
   */
  SomeReturnParcels = 'SOME_RETURN_PARCELS',
  /**
   * **The order has some return slips**
   * @deprecated Use `SOME_RETURNS` instead
   */
  SomeReturnSlips = 'SOME_RETURN_SLIPS'
}

/** **Order tag brand** */
export enum OrderTagBrand {
  /** **The order is available for the brand and requires an action** */
  ActionRequired = 'ACTION_REQUIRED',
  /** **The order is available for the brand and requires an action because claim** */
  ActionRequiredClaim = 'ACTION_REQUIRED_CLAIM',
  /** **The order is available for the brand and requires an action because return** */
  ActionRequiredReturn = 'ACTION_REQUIRED_RETURN',
  /** **The order is available for the brand and requires an action because shipment incident** */
  ActionRequiredShipmentIncident = 'ACTION_REQUIRED_SHIPMENT_INCIDENT',
  /** **The order is available for the brand and requires an action because unfulfilled** */
  ActionRequiredUnfulfilled = 'ACTION_REQUIRED_UNFULFILLED',
  /** **The order is available for the brand** */
  Available = 'AVAILABLE'
}

/** **Order tag claim** */
export enum OrderTagClaim {
  /** **The order has some closed claims** */
  Closed = 'CLOSED',
  /** **The order has no claim** */
  None = 'NONE',
  /** **The order has some opened claims** */
  Opened = 'OPENED'
}

/** **Order tag claim reason** */
export enum OrderTagClaimReason {
  /** **The order has some claims with delivered but damaged reason** */
  DeliveredButDamaged = 'DELIVERED_BUT_DAMAGED',
  /** **The order has some claims with delivered but incomplete reason** */
  DeliveredButIncomplete = 'DELIVERED_BUT_INCOMPLETE',
  /** **The order has some claims with delivered but wrong reason** */
  DeliveredButWrong = 'DELIVERED_BUT_WRONG',
  /** **The order has no claim** */
  None = 'NONE',
  /** **The order has some claims with not delivered and returned to sender reason** */
  NotDeliveredAndReturnedToSender = 'NOT_DELIVERED_AND_RETURNED_TO_SENDER',
  /** **The order has some claims with not delivered and tracking blocked reason** */
  NotDeliveredAndTrackingBlocked = 'NOT_DELIVERED_AND_TRACKING_BLOCKED',
  /** **The order has some claims with not delivered and tracking delivered reason** */
  NotDeliveredAndTrackingDelivered = 'NOT_DELIVERED_AND_TRACKING_DELIVERED',
  /** **The order has some claims with other reason** */
  Other = 'OTHER',
  /** **The order has some claims with voucher not working reason** */
  VoucherNotWorking = 'VOUCHER_NOT_WORKING'
}

/** **Order tag fulfillment** */
export enum OrderTagFulfillment {
  /** **The order has all the items that are eligible to shipment in a shipment** */
  Fulfilled = 'FULFILLED',
  /** **The order has none of the items that are eligible to shipment in a shipment** */
  Unfulfilled = 'UNFULFILLED'
}

/** **Order tag refund** */
export enum OrderTagRefund {
  /** **The order has no refund** */
  None = 'NONE',
  /** **The order has some refunds but not totally refunded** */
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  /** **The order has some refunds and totally refunded** */
  TotallyRefunded = 'TOTALLY_REFUNDED'
}

/** **Order tag reship** */
export enum OrderTagReship {
  /** **The order has no reship** */
  None = 'NONE',
  /** **The order has some reships** */
  Reshipped = 'RESHIPPED'
}

/** **Order tag return** */
export enum OrderTagReturn {
  /** **The order has some canceled returns** */
  Canceled = 'CANCELED',
  /** **The order has some delivered returns** */
  Delivered = 'DELIVERED',
  /** **The order has some in progress returns** */
  InProgress = 'IN_PROGRESS',
  /** **The order has no return** */
  None = 'NONE',
  /** **The order has some requested returns** */
  Requested = 'REQUESTED',
  /** **The order has some validated returns** */
  Validated = 'VALIDATED'
}

/** **Order tag shipment** */
export enum OrderTagShipment {
  /** **The order has some attempt fail shipments** */
  AttemptFail = 'ATTEMPT_FAIL',
  /** **The order has some available for pickup shipments** */
  AvailableForPickup = 'AVAILABLE_FOR_PICKUP',
  /** **The order has some delivered shipments** */
  Delivered = 'DELIVERED',
  /** **The order has some exception shipments** */
  Exception = 'EXCEPTION',
  /** **The order has some expired shipments** */
  Expired = 'EXPIRED',
  /** **The order has some info received shipments** */
  InfoReceived = 'INFO_RECEIVED',
  /** **The order has some in transit shipments** */
  InTransit = 'IN_TRANSIT',
  /** **The order has no shipment** */
  None = 'NONE',
  /** **The order has some out for delivery shipments** */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** **The order has some pending shipments** */
  Pending = 'PENDING'
}

/** **Order tag shipping mode** */
export enum OrderTagShippingMode {
  /** **The shipments will be shipped at the recipient's home** */
  Home = 'HOME',
  /** **The order will not be shipped (digital items)** */
  None = 'NONE',
  /** **The shipments will be shipped at a pickup point** */
  PickupPoint = 'PICKUP_POINT'
}

/** **Order tag shopify** */
export enum OrderTagShopify {
  /** **The order has no shopify** */
  None = 'NONE',
  /** **The order has a shopify and is synchronized** */
  Synchronized = 'SYNCHRONIZED',
  /** **The order has a shopify and is not synchronized** */
  Unsynchronized = 'UNSYNCHRONIZED'
}

/** **Order tag status** */
export enum OrderTagStatus {
  /** **The order has been canceled by the customer or by a member of the support team** */
  Canceled = 'CANCELED',
  /** **The order has been placed less than 10 minutes ago** */
  PendingValidation = 'PENDING_VALIDATION',
  /** **The order has been placed more than 10 minutes ago** */
  Validated = 'VALIDATED'
}

/** **Order tag type** */
export enum OrderTagType {
  /** **The order has only digital items** */
  Digital = 'DIGITAL',
  /** **The order has only physical items** */
  Physical = 'PHYSICAL'
}

/** **Order tags** */
export type OrderTags = {
  __typename?: 'OrderTags';
  /** **Brand tags** */
  brand: Array<OrderTagBrand>;
  /** **Claim tags** */
  claim: Array<OrderTagClaim>;
  /** **Claim reason tags** */
  claimReason: Array<OrderTagClaimReason>;
  /** **Fulfillment tag** */
  fulfillment: OrderTagFulfillment;
  /** **Refund tag** */
  refund: OrderTagRefund;
  /** **Reship tag** */
  reship: OrderTagReship;
  /** **Return tags** */
  return: Array<OrderTagReturn>;
  /** **Shipment tags** */
  shipment: Array<OrderTagShipment>;
  /** **Shipping mode tag** */
  shippingMode: OrderTagShippingMode;
  /** **Shopify tag** */
  shopify: OrderTagShopify;
  /** **Status tag** */
  status: OrderTagStatus;
  /** **Type tag** */
  type: OrderTagType;
};

/** **Orders** */
export type Orders = {
  __typename?: 'Orders';
  /** **Nodes** */
  nodes: Array<Order>;
  /** **Paging** */
  paging: Paging;
  /** **Total count** */
  totalCount: Scalars['PositiveInteger']['output'];
};

/** **Orders by tracking input** */
export type OrdersByTrackingInput = {
  /** **Identifier of the sale** */
  saleId: Scalars['ID']['input'];
  /** **Tracking courier slug** */
  trackingCourierSlug: Scalars['String']['input'];
  /** **Tracking number** */
  trackingNumber: Scalars['String']['input'];
};

/** **Orders counters** */
export type OrdersCounters = {
  __typename?: 'OrdersCounters';
  /** **Tagging counters** */
  tagging: OrdersTaggingCounters;
};

/** **Orders export** */
export type OrdersExport = {
  __typename?: 'OrdersExport';
  /** **File URL** */
  fileUrl?: Maybe<Scalars['String']['output']>;
};

/** **Orders export file extension** */
export enum OrdersExportFileExtension {
  /** **CSV** */
  Csv = 'CSV',
  /** **XLSX (excel)** */
  Xlsx = 'XLSX'
}

/** **Orders export input** */
export type OrdersExportInput = {
  /** **File extension** */
  fileExtension: OrdersExportFileExtension;
  /** **File format (only available for the Choose team)** */
  fileFormat?: InputMaybe<Logistician>;
  /** **Filter** */
  filter?: InputMaybe<OrdersFilterInput>;
  /** **Search** */
  search?: InputMaybe<OrdersSearchInput>;
  /** **Sort** */
  sort: OrdersSortInput;
};

/** **Orders filter creation date input** */
export type OrdersFilterCreationDateInput = {
  /** **Filter from this creation date** */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** **Filter to this creation date** */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** **Orders filter input** */
export type OrdersFilterInput = {
  /** **Filter with creation date** */
  creationDate?: InputMaybe<OrdersFilterCreationDateInput>;
  /** **Filter with item reference** */
  itemReference?: InputMaybe<Scalars['String']['input']>;
  /** **Filter with tagging** */
  tagging?: InputMaybe<OrdersFilterTaggingInput>;
};

/** **Orders filter tagging input** */
export type OrdersFilterTaggingInput = {
  /** **Filter on brand tags** */
  brand?: InputMaybe<Array<OrderTagBrand>>;
  /** **Filter on claim tags** */
  claim?: InputMaybe<Array<OrderTagClaim>>;
  /** **Filter on claim reason tags** */
  claimReason?: InputMaybe<Array<OrderTagClaimReason>>;
  /** **Filter on fulfillment tags** */
  fulfillment?: InputMaybe<Array<OrderTagFulfillment>>;
  /** **Filter on refund tags** */
  refund?: InputMaybe<Array<OrderTagRefund>>;
  /** **Filter on reship tags** */
  reship?: InputMaybe<Array<OrderTagReship>>;
  /** **Filter on return tags** */
  return?: InputMaybe<Array<OrderTagReturn>>;
  /** **Filter on shipment tags** */
  shipment?: InputMaybe<Array<OrderTagShipment>>;
  /** **Filter on shipping mode tags** */
  shippingMode?: InputMaybe<Array<OrderTagShippingMode>>;
  /** **Filter on shopify tags** */
  shopify?: InputMaybe<Array<OrderTagShopify>>;
  /** **Filter on status tags** */
  status?: InputMaybe<Array<OrderTagStatus>>;
  /** **Filter on type tags** */
  type?: InputMaybe<Array<OrderTagType>>;
};

/** **Orders input** */
export type OrdersInput = {
  /** **Filter** */
  filter?: InputMaybe<OrdersFilterInput>;
  /** **Paging** */
  paging: PagingInput;
  /** **Search** */
  search?: InputMaybe<OrdersSearchInput>;
  /** **Sort** */
  sort: OrdersSortInput;
};

/** **Orders filter search field input** */
export enum OrdersSearchFieldInput {
  /** **Search in all available fields (order identifier, recipient full name and item SKU)** */
  All = 'ALL'
}

/** **Orders search input** */
export type OrdersSearchInput = {
  /** **Field to search into** */
  field: OrdersSearchFieldInput;
  /** **Term to search** */
  term: Scalars['NonEmptyString']['input'];
};

/** **Orders sort field input** */
export enum OrdersSortFieldInput {
  /** **Sort on claim creation date** */
  ClaimCreationDate = 'CLAIM_CREATION_DATE',
  /** **Sort on creation date** */
  CreationDate = 'CREATION_DATE',
  /** **Sort on recipient full name** */
  RecipientFullName = 'RECIPIENT_FULL_NAME',
  /** **Sort on brand tag** */
  TagBrand = 'TAG_BRAND',
  /** **Sort on claim tag** */
  TagClaim = 'TAG_CLAIM',
  /** **Sort on claim reason tag** */
  TagClaimReason = 'TAG_CLAIM_REASON',
  /** **Sort on fulfillment tag** */
  TagFulfillment = 'TAG_FULFILLMENT',
  /** **Sort on refund tag** */
  TagRefund = 'TAG_REFUND',
  /** **Sort on reship tag** */
  TagReship = 'TAG_RESHIP',
  /** **Sort on return tag** */
  TagReturn = 'TAG_RETURN',
  /** **Sort on shipment tag** */
  TagShipment = 'TAG_SHIPMENT',
  /** **Sort on shipping mode tag** */
  TagShippingMode = 'TAG_SHIPPING_MODE',
  /** **Sort on shopify tag** */
  TagShopify = 'TAG_SHOPIFY',
  /** **Sort on status tag** */
  TagStatus = 'TAG_STATUS',
  /** **Sort on type tag** */
  TagType = 'TAG_TYPE',
  /** **Sort on total price sold** */
  TotalPriceSold = 'TOTAL_PRICE_SOLD'
}

/** **Orders sort input** */
export type OrdersSortInput = {
  /** **Field to sort** */
  field: OrdersSortFieldInput;
  /** **Order to sort** */
  order: OrdersSortOrderInput;
};

/** **Orders sort order input** */
export enum OrdersSortOrderInput {
  /** **Sort in ascending order** */
  Ascending = 'ASCENDING',
  /** **Sort in descending order** */
  Descending = 'DESCENDING'
}

/** **Orders tag brand counters** */
export type OrdersTagBrandCounters = {
  __typename?: 'OrdersTagBrandCounters';
  actionRequired: Scalars['PositiveInteger']['output'];
  actionRequiredClaim: Scalars['PositiveInteger']['output'];
  actionRequiredReturn: Scalars['PositiveInteger']['output'];
  actionRequiredShipmentIncident: Scalars['PositiveInteger']['output'];
  actionRequiredUnfulfilled: Scalars['PositiveInteger']['output'];
  available: Scalars['PositiveInteger']['output'];
};

/** **Orders tag claim counters** */
export type OrdersTagClaimCounters = {
  __typename?: 'OrdersTagClaimCounters';
  closed: Scalars['PositiveInteger']['output'];
  none: Scalars['PositiveInteger']['output'];
  opened: Scalars['PositiveInteger']['output'];
};

/** **Orders tag claim reason counters** */
export type OrdersTagClaimReasonCounters = {
  __typename?: 'OrdersTagClaimReasonCounters';
  deliveredButDamaged: Scalars['PositiveInteger']['output'];
  deliveredButIncomplete: Scalars['PositiveInteger']['output'];
  deliveredButWrong: Scalars['PositiveInteger']['output'];
  none: Scalars['PositiveInteger']['output'];
  notDeliveredAndReturnedToSender: Scalars['PositiveInteger']['output'];
  notDeliveredAndTrackingBlocked: Scalars['PositiveInteger']['output'];
  notDeliveredAndTrackingDelivered: Scalars['PositiveInteger']['output'];
  other: Scalars['PositiveInteger']['output'];
  voucherNotWorking: Scalars['PositiveInteger']['output'];
};

/** **Orders tag fulfillment counters** */
export type OrdersTagFulfillmentCounters = {
  __typename?: 'OrdersTagFulfillmentCounters';
  fulfilled: Scalars['PositiveInteger']['output'];
  unfulfilled: Scalars['PositiveInteger']['output'];
};

/** **Orders tag refund counters** */
export type OrdersTagRefundCounters = {
  __typename?: 'OrdersTagRefundCounters';
  none: Scalars['PositiveInteger']['output'];
  partiallyRefunded: Scalars['PositiveInteger']['output'];
  totallyRefunded: Scalars['PositiveInteger']['output'];
};

/** **Orders tag reship counters** */
export type OrdersTagReshipCounters = {
  __typename?: 'OrdersTagReshipCounters';
  none: Scalars['PositiveInteger']['output'];
  reshipped: Scalars['PositiveInteger']['output'];
};

/** **Orders tag return counters** */
export type OrdersTagReturnCounters = {
  __typename?: 'OrdersTagReturnCounters';
  canceled: Scalars['PositiveInteger']['output'];
  delivered: Scalars['PositiveInteger']['output'];
  inProgress: Scalars['PositiveInteger']['output'];
  none: Scalars['PositiveInteger']['output'];
  requested: Scalars['PositiveInteger']['output'];
  validated: Scalars['PositiveInteger']['output'];
};

/** **Orders tag shipment counters** */
export type OrdersTagShipmentCounters = {
  __typename?: 'OrdersTagShipmentCounters';
  attemptFail: Scalars['PositiveInteger']['output'];
  availableForPickup: Scalars['PositiveInteger']['output'];
  delivered: Scalars['PositiveInteger']['output'];
  exception: Scalars['PositiveInteger']['output'];
  expired: Scalars['PositiveInteger']['output'];
  inTransit: Scalars['PositiveInteger']['output'];
  infoReceived: Scalars['PositiveInteger']['output'];
  none: Scalars['PositiveInteger']['output'];
  outForDelivery: Scalars['PositiveInteger']['output'];
  pending: Scalars['PositiveInteger']['output'];
};

/** **Orders tag shipping mode counters** */
export type OrdersTagShippingModeCounters = {
  __typename?: 'OrdersTagShippingModeCounters';
  home: Scalars['PositiveInteger']['output'];
  none: Scalars['PositiveInteger']['output'];
  pickupPoint: Scalars['PositiveInteger']['output'];
};

/** **Orders tag shopify counters** */
export type OrdersTagShopifyCounters = {
  __typename?: 'OrdersTagShopifyCounters';
  none: Scalars['PositiveInteger']['output'];
  synchronized: Scalars['PositiveInteger']['output'];
  unsynchronized: Scalars['PositiveInteger']['output'];
};

/** **Orders tag status counters** */
export type OrdersTagStatusCounters = {
  __typename?: 'OrdersTagStatusCounters';
  canceled: Scalars['PositiveInteger']['output'];
  pendingValidation: Scalars['PositiveInteger']['output'];
  validated: Scalars['PositiveInteger']['output'];
};

/** **Orders tag type counters** */
export type OrdersTagTypeCounters = {
  __typename?: 'OrdersTagTypeCounters';
  digital: Scalars['PositiveInteger']['output'];
  physical: Scalars['PositiveInteger']['output'];
};

/** **Orders tagging counters** */
export type OrdersTaggingCounters = {
  __typename?: 'OrdersTaggingCounters';
  /** **Tag brand counters** */
  brand: OrdersTagBrandCounters;
  /** **Tag claim counters** */
  claim: OrdersTagClaimCounters;
  /** **Tag claim reason counters** */
  claimReason: OrdersTagClaimReasonCounters;
  /** **Tag fulfillment counters** */
  fulfillment: OrdersTagFulfillmentCounters;
  /** **Tag refund counters** */
  refund: OrdersTagRefundCounters;
  /** **Tag reship counters** */
  reship: OrdersTagReshipCounters;
  /** **Tag return counters** */
  return: OrdersTagReturnCounters;
  /** **Tag shipment counters** */
  shipment: OrdersTagShipmentCounters;
  /** **Tag shipping mode counters** */
  shippingMode: OrdersTagShippingModeCounters;
  /** **Tag shopify counters** */
  shopify: OrdersTagShopifyCounters;
  /** **Tag status counters** */
  status: OrdersTagStatusCounters;
  /** **Tag type counters** */
  type: OrdersTagTypeCounters;
};

/** **Orders unfulfilled export input** */
export type OrdersUnfulfilledExportInput = {
  /** **File extension** */
  fileExtension: OrdersExportFileExtension;
  /** **File format** */
  fileFormat?: InputMaybe<Logistician>;
};

/** **Paging** */
export type Paging = {
  __typename?: 'Paging';
  /** **End cursor** */
  endCursor?: Maybe<Scalars['ID']['output']>;
  /** **Has next page ?** */
  hasNextPage: Scalars['Boolean']['output'];
  /** **Has previous page ?** */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** **Page size** */
  pageSize: Scalars['PositiveInteger']['output'];
  /** **Start cursor** */
  startCursor?: Maybe<Scalars['ID']['output']>;
};

/** **Paging input** */
export type PagingInput = {
  /** **After cursor** */
  afterCursor?: InputMaybe<Scalars['ID']['input']>;
  /** **Before cursor** */
  beforeCursor?: InputMaybe<Scalars['ID']['input']>;
  /** **Page size** */
  pageSize: Scalars['PositiveInteger']['input'];
};

/** **Parcel** */
export type Parcel = {
  __typename?: 'Parcel';
  /** **Estimated delivery date range** */
  estimatedDeliveryDateRange?: Maybe<ParcelEstimatedDeliveryDateRange>;
  /**
   * **Does the parcel has its tracking stucked or not ?**
   *
   * - only if more than 3 days in 'pending' for now
   */
  hasTrackingStucked: Scalars['Boolean']['output'];
  /** **ID** */
  id: Scalars['ID']['output'];
  /** **Items** */
  items: Array<Item>;
  /** **Recipient** */
  recipient: Recipient;
  /** **Date when the parcel was picked up by the carrier** */
  trackingCarrierPickedUpAt?: Maybe<Scalars['DateTime']['output']>;
  /** **Tracking carrier slug** */
  trackingCarrierSlug: Scalars['String']['output'];
  /** **Tracking courier** */
  trackingCourier: Courier;
  /** **Date when the parcel was delivered** */
  trackingDeliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** **Tracking number** */
  trackingNumber: Scalars['String']['output'];
  /** **Tracking status** */
  trackingStatus: TrackingStatus;
  /** **Tracking sub status** */
  trackingSubStatus?: Maybe<TrackingSubStatus>;
  /** **Date of the last tracking update** */
  trackingUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** **Tracking URL** */
  trackingUrl: Scalars['String']['output'];
};

/** **Parcel estimated delivery date range** */
export type ParcelEstimatedDeliveryDateRange = {
  __typename?: 'ParcelEstimatedDeliveryDateRange';
  /** **Max** */
  max: Scalars['DateTime']['output'];
  /** **Min** */
  min: Scalars['DateTime']['output'];
};

/** **Payment processor** */
export enum PaymentProcessor {
  /** **Alma** */
  Alma = 'Alma',
  /** **Braintree** */
  Braintree = 'Braintree',
  /** **Choose** */
  Choose = 'Choose',
  /** **Primer** */
  Primer = 'Primer',
  /** **Stripe** */
  Stripe = 'Stripe'
}

/** **Payment Sub-processor - Stripe Specific ** */
export enum PaymentSubProcessor {
  /** **Bancontact** */
  Bancontact = 'Bancontact',
  /** **Klarna** */
  Klarna = 'Klarna',
  /** **PayPal** */
  PayPal = 'PayPal',
  /** **RevolutPay** */
  RevolutPay = 'RevolutPay'
}

/** **Pickup point address** */
export type PickupAddress = {
  __typename?: 'PickupAddress';
  /** **city** */
  city: Scalars['String']['output'];
  /** **Country code** */
  countryCode: Scalars['String']['output'];
  /** **name** */
  name: Scalars['String']['output'];
  /** **street** */
  street: Scalars['String']['output'];
  /** **streetAdditional** */
  streetAdditional?: Maybe<Scalars['String']['output']>;
  /** **zipCode** */
  zipCode: Scalars['String']['output'];
};

/** **Pickup point** */
export type PickupPoint = {
  __typename?: 'PickupPoint';
  /** **Address** */
  address?: Maybe<PickupAddress>;
  /** **Country code** */
  countryCode: Scalars['String']['output'];
  /** **Id** */
  id: Scalars['ID']['output'];
  /** **Network** */
  network: PickupPointNetwork;
};

/** **Pickup point network** */
export enum PickupPointNetwork {
  /** **Colissimo** */
  Colissimo = 'COLISSIMO',
  /** **Mondial relay** */
  MondialRelay = 'MONDIAL_RELAY',
  /** **Shop2Shop** */
  Shop2Shop = 'SHOP2SHOP'
}

export type PostRegisterConfig = {
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
};

export enum PostRegisterResult {
  Done = 'DONE',
  Merged = 'MERGED'
}

/** Preferred refund method */
export enum PreferredRefundMethod {
  /** User want to be refunded with Choose credit */
  ChooseCredit = 'ChooseCredit',
  /** User want to be refunded with the initial payment method */
  InitialPaymentMethod = 'InitialPaymentMethod'
}

/** **Price** */
export type Price = {
  __typename?: 'Price';
  /** **Currency ISO code** */
  currency: CurrencyIso;
  /** **Value with VAT (in cents)** */
  valueWithVat: Scalars['Int']['output'];
  /** **Value without VAT (in cents)** */
  valueWithoutVat: Scalars['Int']['output'];
};

export type Product = {
  __typename?: 'Product';
  /** **Product ID** */
  id: Scalars['ID']['output'];
  /** **Is digital ?** */
  isDigital: Scalars['Boolean']['output'];
  /** **Product name** */
  name: Scalars['String']['output'];
  /** **Product variants** */
  variants: Array<ProductVariant>;
};

export type ProductSoldErrorV2 = {
  __typename?: 'ProductSoldErrorV2';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  order_id: Scalars['String']['output'];
  product_id: Scalars['String']['output'];
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  /** **GTIN** */
  gtin?: Maybe<Scalars['String']['output']>;
  /** **Product variant ID** */
  id: Scalars['ID']['output'];
  /** **Product variant thumbnail** */
  image?: Maybe<Scalars['String']['output']>;
  /** **Product ID** */
  productId: Scalars['ID']['output'];
  /** **SKU** */
  sku?: Maybe<Scalars['String']['output']>;
  /** **Stock** */
  stock: Stock;
  /** **Stock alerts summary** */
  stockAlertsSummary: StockAlertsSummary;
  /** **Variant title** */
  title?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** **Billing export** */
  billingExport: BillingExport;
  /** **Get information about state of billing** */
  billingStateV2: BillingStateV2;
  /** **Billing** */
  billingV2: BillingV2;
  brandInfo?: Maybe<BrandInfo>;
  /** **Get current authenticated user** */
  currentUser: User;
  /** **Detects the couriers using the input (order id and tracking number)** */
  detectCouriers: Array<Courier>;
  getBrandsAccess: Array<Maybe<BrandAccess>>;
  getInviteCode: Scalars['String']['output'];
  /** **Gets the system information** */
  info: SystemInfo;
  /** **Gets the invoices for a sale** */
  invoices: Array<Invoice>;
  members: Array<Member>;
  /** **Gets the order** */
  order: Order;
  /** **Returns the upload URL for an order return label** */
  orderReturnLabelUploadUrl: Upload;
  /** **Gets the orders** */
  orders: Orders;
  /** **Gets the orders using the tracking input (sale id, tracking courier slug and tracking number)** */
  ordersByTracking: Array<Order>;
  /** **Orders counters** */
  ordersCounters: OrdersCounters;
  /** **Orders export** */
  ordersExport: OrdersExport;
  /** **Orders unfulfilled export** */
  ordersUnfulfilledExport: OrdersExport;
  /** **Get list of products for a sale** */
  products: Array<Product>;
  /** **Searches the couriers using their name** */
  searchCouriers: Array<Courier>;
  /** **Searches all couriers by supported countries** */
  searchCouriersBySupportedCountries: Array<Courier>;
  /** **Stocks export** */
  stocksExport: StocksExport;
  /** **Gets supplier billing adjustment** */
  supplierBillingAdjustment?: Maybe<SupplierBillingAdjustment>;
  /** **Gets sale supplier billing adjustments** */
  supplierBillingAdjustments: Array<SupplierBillingAdjustment>;
  /** **Gets the supplier billing state** */
  supplierBillingState: SupplierBillingState;
  /** **Couriers used by the brand to ship orders** */
  usedCouriers: Array<Courier>;
};


export type QueryBillingExportArgs = {
  input: BillingExportInput;
  saleId: Scalars['ID']['input'];
};


export type QueryBillingStateV2Args = {
  saleId: Scalars['String']['input'];
};


export type QueryBillingV2Args = {
  saleId: Scalars['ID']['input'];
};


export type QueryBrandInfoArgs = {
  brandId: Scalars['String']['input'];
};


export type QueryDetectCouriersArgs = {
  input: DetectCouriersInput;
};


export type QueryInvoicesArgs = {
  saleId: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderReturnLabelUploadUrlArgs = {
  input: OrderReturnLabelUploadUrlInput;
};


export type QueryOrdersArgs = {
  input: OrdersInput;
  saleId: Scalars['ID']['input'];
};


export type QueryOrdersByTrackingArgs = {
  input: OrdersByTrackingInput;
};


export type QueryOrdersCountersArgs = {
  saleId: Scalars['ID']['input'];
  sellerId: Scalars['ID']['input'];
};


export type QueryOrdersExportArgs = {
  input: OrdersExportInput;
  saleId: Scalars['ID']['input'];
  sellerId: Scalars['ID']['input'];
};


export type QueryOrdersUnfulfilledExportArgs = {
  input: OrdersUnfulfilledExportInput;
  saleId: Scalars['ID']['input'];
  sellerId: Scalars['ID']['input'];
};


export type QueryProductsArgs = {
  saleId: Scalars['ID']['input'];
};


export type QuerySearchCouriersArgs = {
  input: SearchCouriersInput;
};


export type QuerySearchCouriersBySupportedCountriesArgs = {
  input: SearchCouriersBySupportedCountries;
};


export type QueryStocksExportArgs = {
  input: StocksExportInput;
  saleId: Scalars['ID']['input'];
};


export type QuerySupplierBillingAdjustmentArgs = {
  supplierBillingAdjustmentId: Scalars['ID']['input'];
};


export type QuerySupplierBillingAdjustmentsArgs = {
  saleId: Scalars['ID']['input'];
};


export type QuerySupplierBillingStateArgs = {
  saleId: Scalars['ID']['input'];
};

/** **The recipient is the person who will receive the order** */
export type Recipient = {
  __typename?: 'Recipient';
  /** **Address** */
  address: Address;
  /** **Email** */
  email: Scalars['String']['output'];
  /** **First name** */
  firstName: Scalars['String']['output'];
  /** **Full name ("first_name last_name")** */
  fullName: Scalars['String']['output'];
  /** **Identifier** */
  id: Scalars['ID']['output'];
  /** Is editable ? */
  isEditable: Scalars['Boolean']['output'];
  /** **Last name** */
  lastName: Scalars['String']['output'];
  /** **Phone number** */
  phoneNumber: Scalars['String']['output'];
  /** **Previous recipient if it has been updated** */
  previous?: Maybe<Recipient>;
};

/** Return */
export type Return = {
  __typename?: 'Return';
  /** Cancelation date */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  /** Claim id */
  claimId?: Maybe<Scalars['ID']['output']>;
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier */
  id: Scalars['ID']['output'];
  /** Whether the validation is locked */
  isValidationLocked: Scalars['Boolean']['output'];
  /** Label file URL */
  labelFileUrl: Scalars['String']['output'];
  /** Lines */
  lines: Array<ReturnLine>;
  /** Order id */
  orderId: Scalars['ID']['output'];
  /** Preferred refund method */
  preferredRefundMethod: PreferredRefundMethod;
  /** Requester */
  requestedBy: ReturnRequester;
  /** Status */
  status: ReturnStatus;
  /** Tracking */
  tracking: Tracking;
  /** Tracking id */
  trackingId: Scalars['ID']['output'];
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
  /** Validation date */
  validatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Return line */
export type ReturnLine = {
  __typename?: 'ReturnLine';
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Identifier */
  id: Scalars['ID']['output'];
  /** Item */
  item: Item;
  /** Item id */
  itemId: Scalars['ID']['output'];
  /** Reason */
  reason: ReturnLineReason;
  /** Return id */
  returnId: Scalars['ID']['output'];
  /** Sub reason */
  subReason?: Maybe<ReturnLineSubReason>;
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
};

/** Return line reason */
export enum ReturnLineReason {
  /** The item is of bad quality */
  BadQuality = 'BadQuality',
  /** A better price is available elsewhere */
  BetterPriceAvailableElsewhere = 'BetterPriceAvailableElsewhere',
  /** The supplier has requested a return in response to a claim */
  Claim = 'Claim',
  /** The item is damaged */
  DamagedItem = 'DamagedItem',
  /** The shipping is damaged */
  DamagedShipping = 'DamagedShipping',
  /** The item was delivered too late */
  DeliveredTooLate = 'DeliveredTooLate',
  /** The item does not match the description */
  DoNotMatchDescription = 'DoNotMatchDescription',
  /** The item does not match the picture */
  DoNotMatchPicture = 'DoNotMatchPicture',
  /** Other reason */
  Other = 'Other',
  /** The size is not correct */
  Size = 'Size',
  /** The item is wrong */
  WrongItem = 'WrongItem'
}

/** Return line sub reason */
export enum ReturnLineSubReason {
  /** The size does not fit */
  SizeDoesNotFit = 'SizeDoesNotFit',
  /** The size is other */
  SizeOther = 'SizeOther',
  /** The customer has ordered several sizes */
  SizeSeveralSizesOrdered = 'SizeSeveralSizesOrdered',
  /** The size is too long */
  SizeTooLong = 'SizeTooLong',
  /** The size is too short */
  SizeTooShort = 'SizeTooShort',
  /** The size is too tight */
  SizeTooTight = 'SizeTooTight',
  /** The size is too wide */
  SizeTooWide = 'SizeTooWide'
}

/** Return requester */
export enum ReturnRequester {
  /** A member of the Choose team has requested the return */
  Choose = 'Choose',
  /** The customer has requested the return */
  Customer = 'Customer',
  /** The supplier has requested the return */
  Supplier = 'Supplier'
}

/** Return status */
export enum ReturnStatus {
  /** Canceled */
  Canceled = 'Canceled',
  /** Delivered */
  Delivered = 'Delivered',
  /** In progress */
  InProgress = 'InProgress',
  /** Requested */
  Requested = 'Requested',
  /** Validated */
  Validated = 'Validated'
}

/** **Sale status** */
export enum SaleStatus {
  /** **Sale is ended** */
  Ended = 'ENDED',
  /** **Sale is ongoing** */
  Ongoing = 'ONGOING',
  /** **Sale is upcoming** */
  Upcoming = 'UPCOMING'
}

/** **Search couriers by supported countries input** */
export type SearchCouriersBySupportedCountries = {
  /** **Country code iso3** */
  countryCodeIso3: Scalars['String']['input'];
};

/** **Search couriers input** */
export type SearchCouriersInput = {
  /** **Name of the courier** */
  name: Scalars['String']['input'];
};

export enum SetStockErrorCode {
  /** **Quantity not valid** */
  QuantityNotValid = 'QUANTITY_NOT_VALID',
  /** **Stock not found** */
  StockNotFound = 'STOCK_NOT_FOUND',
  /** **Update disabled for coupons or if sale is synchronized from Shopify** */
  UpdateDisabled = 'UPDATE_DISABLED'
}

/** **Stock update** */
export type SetStockInput = {
  /**
   * **Quantity**
   *
   * A positive integer is expected. Values above 10000 will be capped to 10000.
   */
  quantity: Scalars['Int']['input'];
  /** **Stock ID** */
  stockId: Scalars['ID']['input'];
};

/** **Shopify order integration** */
export type ShopifyOrderIntegration = {
  __typename?: 'ShopifyOrderIntegration';
  /** **Count ID of the order from Shopify** */
  orderCountId?: Maybe<Scalars['ID']['output']>;
  /** **ID of the order from Shopify** */
  orderId: Scalars['ID']['output'];
  /** **URL of the order from Shopify** */
  orderUrl: Scalars['String']['output'];
};

/** **Get list of products for a sale** */
export type Stock = {
  __typename?: 'Stock';
  /** **Stock ID** */
  id: Scalars['ID']['output'];
  /** **Stock quantity** */
  quantity: Scalars['Int']['output'];
};

export type StockAlertsSummary = {
  __typename?: 'StockAlertsSummary';
  /** **Number of active stock alerts** */
  activeAlertsCount: Scalars['Int']['output'];
  /** **Number of archived stock alerts** */
  archivedAlertsCount: Scalars['Int']['output'];
  /**
   * **Potential revenue if all active alerts are converted to sales with sufficient restocking**
   * Amount in cents
   */
  potentialRevenue: Scalars['Int']['output'];
};

/** **Stocks export** */
export type StocksExport = {
  __typename?: 'StocksExport';
  /** **File URL** */
  fileUrl: Scalars['URL']['output'];
};

/** **Stocks export input** */
export type StocksExportInput = {
  /** **File extension** */
  fileExtension: FileExtension;
};

export enum Store {
  Fr = 'fr',
  Us = 'us'
}

/** **Submit down payment invoice input** */
export type SubmitDownPaymentInput = {
  /** **Invoice storage file key** */
  invoiceStorageFileKey: Scalars['String']['input'];
};

/** **Submit invoice input** */
export type SubmitInvoiceInput = {
  /** **Invoice storage file key** */
  invoiceStorageFileKey: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** **Subscribes to stock updates of a given sale** */
  productsUpdated: Array<Product>;
  shopifyInstalled: Scalars['String']['output'];
  /** **Subscribes to stock updates of a given sale** */
  stocksUpdated: Array<Stock>;
};


export type SubscriptionProductsUpdatedArgs = {
  saleId: Scalars['ID']['input'];
};


export type SubscriptionStocksUpdatedArgs = {
  saleId: Scalars['ID']['input'];
};

export type SupplierBillingAdjustment = SupplierBillingAdjustmentDraft | SupplierBillingAdjustmentValidated;

/** **Supplier billing adjustment is charge to ?** */
export enum SupplierBillingAdjustmentChargeTo {
  /** *Choose* */
  Choose = 'CHOOSE',
  /** *Supplier* */
  Supplier = 'SUPPLIER'
}

/** **Supplier billing adjustment draft mode** */
export type SupplierBillingAdjustmentDraft = {
  __typename?: 'SupplierBillingAdjustmentDraft';
  amountVatExcludedInCents?: Maybe<Scalars['PositiveInteger']['output']>;
  amountVatIncludedInCents?: Maybe<Scalars['PositiveInteger']['output']>;
  chargedTo: SupplierBillingAdjustmentChargeTo;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Scalars['String']['output']>;
  notes: Array<SupplierBillingAdjustmentNote>;
  saleId: Scalars['ID']['output'];
  sellerId: Scalars['ID']['output'];
  supplierBillingAdjustmentId: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vatRate?: Maybe<Scalars['FloatPercentage']['output']>;
};

/** **Supplier billing adjustment note** */
export type SupplierBillingAdjustmentNote = {
  __typename?: 'SupplierBillingAdjustmentNote';
  /** **Note content */
  content: Scalars['String']['output'];
  /** **Note createdAt */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** **Note createdBy */
  createdBy: User;
  /** **Note createdBy Identifier */
  createdById: Scalars['ID']['output'];
  /** **Note deletedAt */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** **Note id */
  id: Scalars['ID']['output'];
  /** **Note supplierBillingAdjustmentId */
  supplierBillingAdjustmentId: Scalars['ID']['output'];
  /** Note updatedAt** */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** **Supplier billing adjustment validated** */
export type SupplierBillingAdjustmentValidated = {
  __typename?: 'SupplierBillingAdjustmentValidated';
  amountVatExcludedInCents: Scalars['PositiveInteger']['output'];
  amountVatIncludedInCents: Scalars['PositiveInteger']['output'];
  chargedTo: SupplierBillingAdjustmentChargeTo;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdById: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documents: Array<Scalars['String']['output']>;
  notes: Array<SupplierBillingAdjustmentNote>;
  saleId: Scalars['ID']['output'];
  sellerId: Scalars['ID']['output'];
  supplierBillingAdjustmentId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  validatedAt: Scalars['DateTime']['output'];
  validatedBy: User;
  validatedById: Scalars['ID']['output'];
  vatRate: Scalars['FloatPercentage']['output'];
};

/** **Supplier billing state** */
export type SupplierBillingState = {
  __typename?: 'SupplierBillingState';
  /** **Whether the supplier can access to the supplier billing** */
  canAccess: Scalars['Boolean']['output'];
  /** **Whether the supplier can access to the supplier billing using a bypass (set by the Choose team)** */
  canAccessBypassed: Scalars['Boolean']['output'];
  /** **Whether the supplier billing is pending claim closing** */
  isPendingClaimClosing: Scalars['Boolean']['output'];
  /** **Whether the supplier billing is pending order delivery** */
  isPendingOrderDelivery: Scalars['Boolean']['output'];
  /** **Whether the supplier billing is pending return validation** */
  isPendingReturnValidation: Scalars['Boolean']['output'];
  /** **Whether the supplier billing is pending withdrawal period** */
  isPendingWithdrawalPeriod: Scalars['Boolean']['output'];
  /** **Order identifiers that are pending claim closing** */
  pendingClaimClosingOrderIds: Array<Scalars['ID']['output']>;
  /** **Order identifiers that are pending order delivery** */
  pendingOrderDeliveryOrderIds: Array<Scalars['ID']['output']>;
  /** **Order identifiers that are pending return validation** */
  pendingReturnValidationOrderIds: Array<Scalars['ID']['output']>;
  /** **Sale status** */
  saleStatus: SupplierBillingStateSaleStatus;
  /** **Date when the withdrawal period is passed** */
  withdrawalPeriodEndDate: Scalars['DateTime']['output'];
  /** **Duration in days of the withdrawal period** */
  withdrawalPeriodInDays: Scalars['PositiveInteger']['output'];
};

/** **Supplier billing state sale status** */
export enum SupplierBillingStateSaleStatus {
  /** **Sale is ended** */
  Ended = 'ENDED',
  /** **Sale is ongoing** */
  Ongoing = 'ONGOING',
  /** **Sale is upcoming** */
  Upcoming = 'UPCOMING'
}

/** **Swap order parcel input** */
export type SwapOrderParcelInput = {
  /** **Order id** */
  orderId: Scalars['ID']['input'];
  /** **Tracking info** */
  trackingInfo: TrackingInfoInput;
};

/** **System information** */
export type SystemInfo = {
  __typename?: 'SystemInfo';
  /** **Environment** */
  environment: Scalars['String']['output'];
  /** **Version** */
  version: Scalars['String']['output'];
};

/** Tracking */
export type Tracking = {
  __typename?: 'Tracking';
  /** Courier */
  courier: Courier;
  /** Courier slug */
  courierSlug: Scalars['String']['output'];
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  /** Delivery date */
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifier */
  id: Scalars['ID']['output'];
  /** Number */
  number: Scalars['String']['output'];
  /** Status */
  status: TrackingStatus;
  /** Sub status */
  subStatus: TrackingSubStatus;
  /** Latest update date */
  updatedAt: Scalars['DateTime']['output'];
  /** URL */
  url: Scalars['String']['output'];
};

/** **Tracking info input** */
export type TrackingInfoInput = {
  /** **Tracking courier slug** */
  trackingCourierSlug: Scalars['String']['input'];
  /** **Tracking number** */
  trackingNumber: Scalars['String']['input'];
};

/** **Tracking status** */
export enum TrackingStatus {
  /** **Attempt fail** */
  AttemptFail = 'ATTEMPT_FAIL',
  /** **Available for pickup** */
  AvailableForPickup = 'AVAILABLE_FOR_PICKUP',
  /** **Delivered** */
  Delivered = 'DELIVERED',
  /** **Exception** */
  Exception = 'EXCEPTION',
  /** **Expired** */
  Expired = 'EXPIRED',
  /** **Info received** */
  InfoReceived = 'INFO_RECEIVED',
  /** **In transit** */
  InTransit = 'IN_TRANSIT',
  /** **Out for delivery** */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** **Pending** */
  Pending = 'PENDING'
}

/** **Tracking sub status** */
export enum TrackingSubStatus {
  /** **Business is closed at the time of delivery (AttemptFail_003)** */
  AttemptFailBusinessClosed = 'ATTEMPT_FAIL_BUSINESS_CLOSED',
  /** **The delivery of the package failed due to some reason. Courier usually leaves a notice and will try to deliver again (AttemptFail_001)** */
  AttemptFailDueToSomeReason = 'ATTEMPT_FAIL_DUE_TO_SOME_REASON',
  /** **Recipient not available at the given address (AttemptFail_002)** */
  AttemptFailRecipientNotAvailable = 'ATTEMPT_FAIL_RECIPIENT_NOT_AVAILABLE',
  /** **The package arrived at a pickup point near you and is available for pickup (AvailableForPickup_001)** */
  AvailableForPickup = 'AVAILABLE_FOR_PICKUP',
  /** **Package delivered to the recipient and cash collected on delivery (Delivered_004)** */
  DeliveredAndCashCollected = 'DELIVERED_AND_CASH_COLLECTED',
  /** **Package delivered to and signed by the recipient (Delivered_003)** */
  DeliveredAndSignedByRecipient = 'DELIVERED_AND_SIGNED_BY_RECIPIENT',
  /** **CUSTOM: Marked delivered by a bot (Delivered_Mark_By_Bot)** */
  DeliveredMarkedByBot = 'DELIVERED_MARKED_BY_BOT',
  /** **CUSTOM: Marked delivered by the customer (Delivered_Mark_By_Customer)** */
  DeliveredMarkedByCustomer = 'DELIVERED_MARKED_BY_CUSTOMER',
  /** **CUSTOM: Marked delivered by a member of the support team (Delivered_Mark_By_Support)** */
  DeliveredMarkedBySupportTeam = 'DELIVERED_MARKED_BY_SUPPORT_TEAM',
  /** **Package picked up by the recipient (Delivered_002)** */
  DeliveredPickedUpByRecipient = 'DELIVERED_PICKED_UP_BY_RECIPIENT',
  /** **Shipment delivered successfully (Delivered_001)** */
  DeliveredSuccessfully = 'DELIVERED_SUCCESSFULLY',
  /** **The package is on its way back to the sender (Exception_010)** */
  ExceptionBackToSender = 'EXCEPTION_BACK_TO_SENDER',
  /** **The return package has been successfully received by the sender (Exception_011)** */
  ExceptionBackToSenderReceived = 'EXCEPTION_BACK_TO_SENDER_RECEIVED',
  /** **The carrier attempted to pick up the shipment but was unsuccessful (Exception_014)** */
  ExceptionCarrierPickupFailed = 'EXCEPTION_CARRIER_PICKUP_FAILED',
  /** **Shipment damaged (Exception_012)** */
  ExceptionDamaged = 'EXCEPTION_DAMAGED',
  /** **Package delayed due to some issues during the customs clearance (Exception_004)** */
  ExceptionDelayedCustomsClearance = 'EXCEPTION_DELAYED_CUSTOMS_CLEARANCE',
  /** **Package not delivered due to incorrect recipient address (Exception_007)** */
  ExceptionIncorrectRecipientAddress = 'EXCEPTION_INCORRECT_RECIPIENT_ADDRESS',
  /** **Delivery of the package failed as it got lost (Exception_013)** */
  ExceptionLost = 'EXCEPTION_LOST',
  /** **The package being held due to pending payment from the recipient's end (Exception_006)** */
  ExceptionPendingPayment = 'EXCEPTION_PENDING_PAYMENT',
  /** **Package available for the pickup but not collected by the recipient (Exception_008)** */
  ExceptionPickupNotCollectedByRecipient = 'EXCEPTION_PICKUP_NOT_COLLECTED_BY_RECIPIENT',
  /** **Delivery of the package failed as the recipient refused to take the package due to some reason (Exception_003)** */
  ExceptionRecipientRefused = 'EXCEPTION_RECIPIENT_REFUSED',
  /** **Delivery of the package failed as the recipient relocated (Exception_002)** */
  ExceptionRecipientRelocated = 'EXCEPTION_RECIPIENT_RELOCATED',
  /** **Package rejected by the carrier due to noncompliance with its guidelines (Exception_009)** */
  ExceptionRejectedByCarrier = 'EXCEPTION_REJECTED_BY_CARRIER',
  /** **Delivery of the package failed due to some shipping exception (Exception_001)** */
  ExceptionShippingException = 'EXCEPTION_SHIPPING_EXCEPTION',
  /** **Package delayed due to some unforeseen reasons (Exception_005)** */
  ExceptionUnforseenReason = 'EXCEPTION_UNFORSEEN_REASON',
  /** **No tracking information of the shipment, from the last 30 days (Expired_001)** */
  ExpiredNoTrackingInformation = 'EXPIRED_NO_TRACKING_INFORMATION',
  /** **The carrier received a request from the shipper and is about to pick up the shipment (InfoReceived_001)** */
  InfoReceivedAboutToPickup = 'INFO_RECEIVED_ABOUT_TO_PICKUP',
  /** **Shipment accepted by the carrier (InTransit_002)** */
  InTransitAcceptedByCarrier = 'IN_TRANSIT_ACCEPTED_BY_CARRIER',
  /** **Shipment arrived at a hub or sorting center (InTransit_003)** */
  InTransitArrivedAtAHubOrSortingCenter = 'IN_TRANSIT_ARRIVED_AT_A_HUB_OR_SORTING_CENTER',
  /** **International shipment arrived at the destination country / region (InTransit_004)** */
  InTransitArrivedAtDestinationCountryOrRegion = 'IN_TRANSIT_ARRIVED_AT_DESTINATION_COUNTRY_OR_REGION',
  /** **Customs clearance completed (InTransit_005)** */
  InTransitCustomsClearanceCompleted = 'IN_TRANSIT_CUSTOMS_CLEARANCE_COMPLETED',
  /** **Package departed from the facility (InTransit_007)** */
  InTransitDepartedFromFacility = 'IN_TRANSIT_DEPARTED_FROM_FACILITY',
  /** **Shipment forwarded to a different delivery address (InTransit_009)** */
  InTransitForwardedToADifferentDeliveryAddress = 'IN_TRANSIT_FORWARDED_TO_A_DIFFERENT_DELIVERY_ADDRESS',
  /** **Package handed over to customs for clearance (InTransit_006)** */
  InTransitHandedOverToCustomsForClearance = 'IN_TRANSIT_HANDED_OVER_TO_CUSTOMS_FOR_CLEARANCE',
  /** **Shipment on the way (InTransit_001)** */
  InTransitOnTheWay = 'IN_TRANSIT_ON_THE_WAY',
  /** **Problem resolved and shipment in transit (InTransit_008)** */
  InTransitProblemResolved = 'IN_TRANSIT_PROBLEM_RESOLVED',
  /** **The package is out for delivery (OutForDelivery_001)** */
  OutForDelivery = 'OUT_FOR_DELIVERY',
  /** **A delivery appointment is scheduled (OutForDelivery_004)** */
  OutForDeliveryAppointmentScheduled = 'OUT_FOR_DELIVERY_APPOINTMENT_SCHEDULED',
  /** **The recipient is contacted before the final delivery (OutForDelivery_003)** */
  OutForDeliveryRecipientContacted = 'OUT_FOR_DELIVERY_RECIPIENT_CONTACTED',
  /** **Can’t track this type of shipment as the carrier is unrecognized (Pending_006)** */
  PendingCarrierUnrecognized = 'PENDING_CARRIER_UNRECOGNIZED',
  /** **The order has been processed / packaged, but not scanned at a shipping location yet (Pending_003)** */
  PendingNotScanned = 'PENDING_NOT_SCANNED',
  /** **It represents the shipments are pending due to no connection with carrier accounts (Pending_002)** */
  PendingNoConnectionWithCarrier = 'PENDING_NO_CONNECTION_WITH_CARRIER',
  /** **No information available on the carrier website or the tracking number is yet to be tracked (Pending_001)** */
  PendingNoInformationAvailable = 'PENDING_NO_INFORMATION_AVAILABLE',
  /** **There have been no new tracking updates in the last 120 days (Pending_005)** */
  PendingNoUpdate = 'PENDING_NO_UPDATE',
  /** **There is no tracking info available because the carrier is wrong (Pending_004)** */
  PendingWrongCarrier = 'PENDING_WRONG_CARRIER'
}

/** **Update order parcel input** */
export type UpdateOrderParcelInput = {
  /** **Order id** */
  orderId: Scalars['ID']['input'];
  /** **Order ids excluded** */
  orderIdsExcluded?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** **Tracking info** */
  trackingInfo: TrackingInfoInput;
};

/** **Update supplier billing adjustment input** */
export type UpdateSupplierBillingAdjustmentInput = {
  amountVatExcludedInCents?: InputMaybe<Scalars['PositiveInteger']['input']>;
  chargedTo?: InputMaybe<SupplierBillingAdjustmentChargeTo>;
  description?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierBillingAdjustmentId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  vatRate?: InputMaybe<Scalars['FloatPercentage']['input']>;
};

export type Upload = {
  __typename?: 'Upload';
  expiresAt: Scalars['DateTime']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UploadInput = {
  fileMimeType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
};

/** **User of brand dashboard** */
export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  intercomUserHash: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  picture: Scalars['String']['output'];
  preferredLanguage: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type UserPasswordConnection = {
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** **Voucher replacement code input** */
export type VoucherReplacementCodeInput = {
  /** **Original code** */
  originalCode: Scalars['String']['input'];
  /** **Replacement code** */
  replacementCode: Scalars['String']['input'];
};

export type PartialCourierFragment = { __typename?: 'Courier', logoUrl: string, name: string, slug: string };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', userId: string, intercomUserHash: string } };

export type BillingQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type BillingQuery = { __typename?: 'Query', billingV2: { __typename?: 'BillingV2', has_error: boolean, is_subject_to_vat: boolean, is_full_paid: boolean, total_adjustment_ht: number, total_billing_ht: number, total_billing_ttc: number, total_commission_ht: number, total_commission_ttc: number, total_delivery_ht: number, total_delivery_ttc: number, total_operation_ht: number, total_operation_ttc: number, total_refund_ht: number, total_refund_ttc: number, total_remaining_ht: number, total_remaining_ttc: number, total_eee_price_ttc: number, total_eee_price_ht: number, adjustments: Array<
      | { __typename: 'SupplierBillingAdjustmentDraft' }
      | { __typename: 'SupplierBillingAdjustmentValidated', amountVatExcludedInCents: number, amountVatIncludedInCents: number, chargedTo: SupplierBillingAdjustmentChargeTo, supplierBillingAdjustmentId: string, title: string, vatRate: number }
    >, agg_by_vat_rate: Array<{ __typename?: 'BillingByVatV2', vat_rate: string, total_operation_ht: number, total_operation_ttc: number, total_commission_ht: number, total_commission_ttc: number, total_billing_ht: number, total_billing_ttc: number, total_vat: number }>, down_payment?:
      | { __typename: 'DownPaymentClassic', preset: DownPaymentPreset, rate: number, financialDetail: { __typename?: 'FinancialBilling', total_billing_ht: number, total_billing_ttc: number, total_commission_ht: number, total_commission_ttc: number, total_delivery_ht: number, total_delivery_ttc: number, total_operation_ht: number, total_operation_ttc: number, total_refund_ht: number, total_refund_ttc: number, total_remaining_ht: number, total_remaining_ttc: number, agg_by_vat_rate: Array<{ __typename?: 'BillingByVatV2', vat_rate: string, total_operation_ht: number, total_operation_ttc: number, total_commission_ht: number, total_commission_ttc: number, total_billing_ht: number, total_billing_ttc: number, total_vat: number }> }, rules: Array<
          | { __typename: 'ActivationDateRule', activationDate: string, isValidated: boolean }
          | { __typename: 'FulfilledOrderPercentageRule', currentValue: number, isValidated: boolean, targetValue: number }
          | { __typename: 'MinimumAmountInCentsRule', currentValue: number, isValidated: boolean, targetValue: number }
        > }
      | { __typename: 'DownPaymentExceptional', preset: DownPaymentPreset }
     | null, errors: Array<{ __typename: 'ProductSoldErrorV2', id: string, order_id: string, product_id: string, code: string }>, payments: Array<{ __typename?: 'BillingPaymentLine', amountVatExcludedInCents: number, amountVatInCents: number, amountVatIncludedInCents: number, invoiceId: string, paidAt?: string | null }> } };

export type BillingExportQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
  input: BillingExportInput;
}>;


export type BillingExportQuery = { __typename?: 'Query', billingExport: { __typename?: 'BillingExport', fileUrl: string } };

export type BillingStateQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type BillingStateQuery = { __typename?: 'Query', supplierBillingState: { __typename?: 'SupplierBillingState', canAccess: boolean, canAccessBypassed: boolean, isPendingClaimClosing: boolean, isPendingOrderDelivery: boolean, isPendingReturnValidation: boolean, isPendingWithdrawalPeriod: boolean, pendingClaimClosingOrderIds: Array<string>, pendingOrderDeliveryOrderIds: Array<string>, pendingReturnValidationOrderIds: Array<string>, saleStatus: SupplierBillingStateSaleStatus, withdrawalPeriodEndDate: string, withdrawalPeriodInDays: number } };

export type BrandInfoQueryVariables = Exact<{
  brandId: Scalars['String']['input'];
}>;


export type BrandInfoQuery = { __typename?: 'Query', brandInfo?: { __typename?: 'BrandInfo', name: string, acceptContract: boolean, nbUsers: number } | null };

export type BrandsAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandsAccessQuery = { __typename?: 'Query', getBrandsAccess: Array<{ __typename?: 'BrandAccess', brandId: string, brandName: string, role: string, store: Store } | null> };

export type SearchCouriersQueryVariables = Exact<{
  input: SearchCouriersInput;
}>;


export type SearchCouriersQuery = { __typename?: 'Query', searchCouriers: Array<{ __typename?: 'Courier', supportedCountries: Array<string>, logoUrl: string, name: string, slug: string }> };

export type SearchCouriersBySupportedCountriesQueryVariables = Exact<{
  input: SearchCouriersBySupportedCountries;
}>;


export type SearchCouriersBySupportedCountriesQuery = { __typename?: 'Query', searchCouriersBySupportedCountries: Array<{ __typename?: 'Courier', supportedCountries: Array<string>, logoUrl: string, name: string, slug: string }> };

export type DetectCouriersQueryVariables = Exact<{
  input: DetectCouriersInput;
}>;


export type DetectCouriersQuery = { __typename?: 'Query', detectCouriers: Array<{ __typename?: 'Courier', logoUrl: string, name: string, slug: string }> };

export type InviteCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type InviteCodeQuery = { __typename?: 'Query', getInviteCode: string };

export type InfoQueryVariables = Exact<{ [key: string]: never; }>;


export type InfoQuery = { __typename?: 'Query', info: { __typename?: 'SystemInfo', version: string, environment: string } };

export type InvoicesQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices: Array<{ __typename?: 'Invoice', createdAt: string, fileName: string, fileUrl: string, id: string, status: InvoiceStatus, type: InvoiceType }> };

export type JoinOrderReturnLabelForClaimMutationVariables = Exact<{
  input: JoinOrderReturnLabelForClaimInput;
}>;


export type JoinOrderReturnLabelForClaimMutation = { __typename?: 'Mutation', joinOrderReturnLabelForClaim?: any | null };

export type MembersQueryVariables = Exact<{ [key: string]: never; }>;


export type MembersQuery = { __typename?: 'Query', members: Array<{ __typename?: 'Member', userId: string, email: string, role: string, picture: string, firstname: string, lastname: string }> };

export type OrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', order: { __typename?: 'Order', billingId: string, createdAt: string, customerId: string, hasBeenExported: boolean, id: string, initialOrderId?: string | null, isShippingEstimatedTimeExceeded: boolean, isCancelled: boolean, isFullDigital: boolean, reshipOrderId?: string | null, saleId: string, sellerId: string, claims: Array<{ __typename?: 'Claim', acceptedMessage?: string | null, actionFromSeller?: ClaimSellerAction | null, createdAt: string, id: string, isAccepted: boolean, isDeclined: boolean, messageFromSupport?: string | null, otherReasonLabel?: string | null, preferredSolution: ClaimPreferredSolution, proofUrls: Array<string>, reason: ClaimReason, reshipActionErrorReasons: Array<ClaimReshipActionErrorReason>, swornStatementUrls: Array<string>, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isDigital: boolean, isOffered: boolean, isReturnable: boolean, isReturnGenerated: boolean, name: string, newDigitalCouponCode?: string | null, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number, valueWithoutVat: number } }> }>, integration: { __typename?: 'OrderIntegration', errorMessage?: string | null, shopify?: { __typename?: 'ShopifyOrderIntegration', orderCountId?: string | null, orderId: string, orderUrl: string } | null }, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isCancelled: boolean, isDigital: boolean, isOffered: boolean, isReturnGenerated: boolean, isReturnValidated: boolean, name: string, newDigitalCouponCode?: string | null, size?: string | null, sku?: string | null, productId: string, productVariantId: string, returnReasonCode?: ItemReturnReasonCode | null, returnSubReasonCode?: ItemReturnSubReasonCode | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number, valueWithoutVat: number }, refundSummary: { __typename?: 'OrderLineRefundSummary', isTotallyRefunded: boolean, refundedAmountInPercentage: number, refundedAmountInPercentageCoveredByChoose: number, refundedAmountInPercentageCoveredBySupplier: number } }>, linesRefunds: Array<{ __typename?: 'OrderLineRefund', amountInCents: number, coveredBy: OrderLineRefundCover, createdAt: string, id: string, lineId: string, lineType: OrderLineType, reason: OrderLineRefundReason }>, parcels: Array<{ __typename?: 'Parcel', hasTrackingStucked: boolean, id: string, trackingDeliveredAt?: string | null, trackingNumber: string, trackingStatus: TrackingStatus, trackingSubStatus?: TrackingSubStatus | null, trackingUrl: string, trackingUpdatedAt?: string | null, estimatedDeliveryDateRange?: { __typename?: 'ParcelEstimatedDeliveryDateRange', max: string, min: string } | null, items: Array<{ __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, name: string, newDigitalCouponCode?: string | null, id: string, imageUrl: string, isDigital: boolean, isOffered: boolean, isReturnGenerated: boolean, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number, valueWithoutVat: number } }>, recipient: { __typename?: 'Recipient', email: string, firstName: string, fullName: string, lastName: string, phoneNumber: string, address: { __typename?: 'Address', street: string, streetAdditional?: string | null, zipCode: string, city: string, county?: string | null, state?: string | null, country: string, countryCode: string } }, trackingCourier: { __typename?: 'Courier', logoUrl: string, name: string, slug: string } }>, rating?: { __typename?: 'OrderRating', rate: number, message?: string | null } | null, recipient: { __typename?: 'Recipient', id: string, fullName: string, firstName: string, lastName: string, email: string, phoneNumber: string, address: { __typename?: 'Address', street: string, streetAdditional?: string | null, zipCode: string, city: string, county?: string | null, state?: string | null, country: string, countryCode: string }, previous?: { __typename?: 'Recipient', fullName: string, firstName: string, lastName: string, email: string, phoneNumber: string, address: { __typename?: 'Address', street: string, streetAdditional?: string | null, zipCode: string, city: string, county?: string | null, state?: string | null, country: string, countryCode: string } } | null }, reshipOrder?: { __typename?: 'Order', createdAt: string } | null, returns: Array<{ __typename?: 'Return', createdAt: string, claimId?: string | null, id: string, lines: Array<{ __typename?: 'ReturnLine', item: { __typename?: 'Item', digitalCouponCode?: string | null, gtin?: string | null, id: string, imageUrl: string, isDigital: boolean, isOffered: boolean, isReturnGenerated: boolean, newDigitalCouponCode?: string | null, name: string, productId: string, productVariantId: string, size?: string | null, sku?: string | null, priceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number, valueWithoutVat: number } } }>, tracking: { __typename?: 'Tracking', deliveredAt?: string | null, number: string, status: TrackingStatus, updatedAt: string, url: string, courier: { __typename?: 'Courier', logoUrl: string, name: string, slug: string } } }>, shipping: { __typename?: 'OrderShipping', fees: number, feesSold: number, policyId?: string | null, deliveryDateRangeHistory: Array<{ __typename?: 'DeliveryDateRange', start: string, end: string }>, pickupPoint?: { __typename?: 'PickupPoint', id: string, countryCode: string, network: PickupPointNetwork, address?: { __typename?: 'PickupAddress', name: string, street: string, streetAdditional?: string | null, zipCode: string, city: string, countryCode: string } | null } | null }, tags: { __typename?: 'OrderTags', claim: Array<OrderTagClaim>, fulfillment: OrderTagFulfillment, refund: OrderTagRefund, reship: OrderTagReship, return: Array<OrderTagReturn>, shipment: Array<OrderTagShipment> }, totalPriceSold: { __typename?: 'Price', currency: CurrencyIso, valueWithVat: number, valueWithoutVat: number } } };

export type OrderReturnLabelUploadUrlQueryVariables = Exact<{
  input: OrderReturnLabelUploadUrlInput;
}>;


export type OrderReturnLabelUploadUrlQuery = { __typename?: 'Query', orderReturnLabelUploadUrl: { __typename?: 'Upload', expiresAt: string, key: string, url: string } };

export type OrdersByTrackingQueryVariables = Exact<{
  input: OrdersByTrackingInput;
}>;


export type OrdersByTrackingQuery = { __typename?: 'Query', ordersByTracking: Array<{ __typename?: 'Order', id: string, saleId: string, customerId: string, recipient: { __typename?: 'Recipient', id: string, email: string, fullName: string }, parcels: Array<{ __typename?: 'Parcel', trackingNumber: string, trackingCourier: { __typename?: 'Courier', logoUrl: string, name: string, slug: string } }> }> };

export type OrdersLinkedQueryVariables = Exact<{
  input: OrdersByTrackingInput;
}>;


export type OrdersLinkedQuery = { __typename?: 'Query', ordersByTracking: Array<{ __typename?: 'Order', id: string }> };

export type PartialOrderFragment = { __typename?: 'Order', createdAt: string, hasSynchronizationError: boolean, id: string, claims: Array<{ __typename?: 'Claim', createdAt: string }>, items: Array<{ __typename?: 'Item', imageUrl: string }>, parcels: Array<{ __typename?: 'Parcel', hasTrackingStucked: boolean, trackingSubStatus?: TrackingSubStatus | null }>, recipient: { __typename?: 'Recipient', fullName: string }, tags: { __typename?: 'OrderTags', brand: Array<OrderTagBrand>, claim: Array<OrderTagClaim>, claimReason: Array<OrderTagClaimReason>, fulfillment: OrderTagFulfillment, refund: OrderTagRefund, reship: OrderTagReship, return: Array<OrderTagReturn>, shipment: Array<OrderTagShipment>, shopify: OrderTagShopify }, totalPriceSold: { __typename?: 'Price', valueWithVat: number, valueWithoutVat: number, currency: CurrencyIso } };

export type PartialOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type PartialOrderQuery = { __typename?: 'Query', order: { __typename?: 'Order', createdAt: string, hasSynchronizationError: boolean, id: string, claims: Array<{ __typename?: 'Claim', createdAt: string }>, items: Array<{ __typename?: 'Item', imageUrl: string }>, parcels: Array<{ __typename?: 'Parcel', hasTrackingStucked: boolean, trackingSubStatus?: TrackingSubStatus | null }>, recipient: { __typename?: 'Recipient', fullName: string }, tags: { __typename?: 'OrderTags', brand: Array<OrderTagBrand>, claim: Array<OrderTagClaim>, claimReason: Array<OrderTagClaimReason>, fulfillment: OrderTagFulfillment, refund: OrderTagRefund, reship: OrderTagReship, return: Array<OrderTagReturn>, shipment: Array<OrderTagShipment>, shopify: OrderTagShopify }, totalPriceSold: { __typename?: 'Price', valueWithVat: number, valueWithoutVat: number, currency: CurrencyIso } } };

export type ProductsQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, name: string, isDigital: boolean, variants: Array<{ __typename?: 'ProductVariant', id: string, productId: string, title?: string | null, sku?: string | null, gtin?: string | null, image?: string | null, stock: { __typename?: 'Stock', id: string, quantity: number }, stockAlertsSummary: { __typename?: 'StockAlertsSummary', activeAlertsCount: number, archivedAlertsCount: number, potentialRevenue: number } }> }> };

export type OrdersQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
  input: OrdersInput;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: { __typename?: 'Orders', totalCount: number, nodes: Array<{ __typename?: 'Order', createdAt: string, hasSynchronizationError: boolean, id: string, claims: Array<{ __typename?: 'Claim', createdAt: string }>, items: Array<{ __typename?: 'Item', imageUrl: string }>, parcels: Array<{ __typename?: 'Parcel', hasTrackingStucked: boolean, trackingSubStatus?: TrackingSubStatus | null }>, recipient: { __typename?: 'Recipient', fullName: string }, tags: { __typename?: 'OrderTags', brand: Array<OrderTagBrand>, claim: Array<OrderTagClaim>, claimReason: Array<OrderTagClaimReason>, fulfillment: OrderTagFulfillment, refund: OrderTagRefund, reship: OrderTagReship, return: Array<OrderTagReturn>, shipment: Array<OrderTagShipment>, shopify: OrderTagShopify }, totalPriceSold: { __typename?: 'Price', valueWithVat: number, valueWithoutVat: number, currency: CurrencyIso } }>, paging: { __typename?: 'Paging', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, pageSize: number } } };

export type OrdersUnfulfilledDesyncShopifyQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
  input: OrdersInput;
}>;


export type OrdersUnfulfilledDesyncShopifyQuery = { __typename?: 'Query', orders: { __typename?: 'Orders', totalCount: number, nodes: Array<{ __typename?: 'Order', integration: { __typename?: 'OrderIntegration', errorMessage?: string | null } }>, paging: { __typename?: 'Paging', startCursor?: string | null, endCursor?: string | null, hasPreviousPage: boolean, hasNextPage: boolean, pageSize: number } } };

export type OrdersCountersQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
}>;


export type OrdersCountersQuery = { __typename?: 'Query', ordersCounters: { __typename?: 'OrdersCounters', tagging: { __typename?: 'OrdersTaggingCounters', brand: { __typename?: 'OrdersTagBrandCounters', actionRequiredUnfulfilled: number, actionRequiredShipmentIncident: number, actionRequiredClaim: number, actionRequiredReturn: number, actionRequired: number, available: number }, type: { __typename?: 'OrdersTagTypeCounters', digital: number, physical: number }, status: { __typename?: 'OrdersTagStatusCounters', canceled: number, pendingValidation: number, validated: number }, shopify: { __typename?: 'OrdersTagShopifyCounters', none: number, unsynchronized: number, synchronized: number }, shippingMode: { __typename?: 'OrdersTagShippingModeCounters', none: number, pickupPoint: number, home: number }, fulfillment: { __typename?: 'OrdersTagFulfillmentCounters', unfulfilled: number, fulfilled: number }, shipment: { __typename?: 'OrdersTagShipmentCounters', none: number, pending: number, infoReceived: number, inTransit: number, outForDelivery: number, attemptFail: number, availableForPickup: number, delivered: number, exception: number, expired: number }, claim: { __typename?: 'OrdersTagClaimCounters', none: number, opened: number, closed: number }, claimReason: { __typename?: 'OrdersTagClaimReasonCounters', none: number, deliveredButDamaged: number, deliveredButIncomplete: number, deliveredButWrong: number, notDeliveredAndReturnedToSender: number, notDeliveredAndTrackingBlocked: number, notDeliveredAndTrackingDelivered: number, voucherNotWorking: number, other: number }, refund: { __typename?: 'OrdersTagRefundCounters', none: number, partiallyRefunded: number, totallyRefunded: number }, reship: { __typename?: 'OrdersTagReshipCounters', none: number, reshipped: number }, return: { __typename?: 'OrdersTagReturnCounters', none: number, canceled: number, requested: number, inProgress: number, delivered: number, validated: number } } } };

export type OrdersExportQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
  input: OrdersExportInput;
}>;


export type OrdersExportQuery = { __typename?: 'Query', ordersExport: { __typename?: 'OrdersExport', fileUrl?: string | null } };

export type OrdersUnfulfilledExportQueryVariables = Exact<{
  sellerId: Scalars['ID']['input'];
  saleId: Scalars['ID']['input'];
  input: OrdersUnfulfilledExportInput;
}>;


export type OrdersUnfulfilledExportQuery = { __typename?: 'Query', ordersUnfulfilledExport: { __typename?: 'OrdersExport', fileUrl?: string | null } };

export type StocksExportQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
  input: StocksExportInput;
}>;


export type StocksExportQuery = { __typename?: 'Query', stocksExport: { __typename?: 'StocksExport', fileUrl: string } };

type PartialSupplierBillingAdjustment_SupplierBillingAdjustmentDraft_Fragment = { __typename: 'SupplierBillingAdjustmentDraft', chargedTo: SupplierBillingAdjustmentChargeTo, createdAt: string, deletedAt?: string | null, documents: Array<string>, supplierBillingAdjustmentId: string, updatedAt: string, draftAmountVatExcludedInCents?: number | null, draftAmountVatIncludedInCents?: number | null, draftDescription?: string | null, draftTitle?: string | null, draftVatRate?: number | null, createdBy: { __typename?: 'User', userId: string, firstname: string, lastname: string, picture: string } };

type PartialSupplierBillingAdjustment_SupplierBillingAdjustmentValidated_Fragment = { __typename: 'SupplierBillingAdjustmentValidated', amountVatExcludedInCents: number, amountVatIncludedInCents: number, chargedTo: SupplierBillingAdjustmentChargeTo, createdAt: string, deletedAt?: string | null, description: string, documents: Array<string>, supplierBillingAdjustmentId: string, title: string, updatedAt: string, validatedAt: string, vatRate: number, createdBy: { __typename?: 'User', userId: string, firstname: string, lastname: string }, validatedBy: { __typename?: 'User', userId: string, firstname: string, lastname: string } };

export type PartialSupplierBillingAdjustmentFragment =
  | PartialSupplierBillingAdjustment_SupplierBillingAdjustmentDraft_Fragment
  | PartialSupplierBillingAdjustment_SupplierBillingAdjustmentValidated_Fragment
;

export type SupplierBillingAdjustmentQueryVariables = Exact<{
  supplierBillingAdjustmentId: Scalars['ID']['input'];
  withNotes: Scalars['Boolean']['input'];
}>;


export type SupplierBillingAdjustmentQuery = { __typename?: 'Query', supplierBillingAdjustment?:
    | { __typename: 'SupplierBillingAdjustmentDraft', chargedTo: SupplierBillingAdjustmentChargeTo, createdAt: string, deletedAt?: string | null, documents: Array<string>, supplierBillingAdjustmentId: string, updatedAt: string, draftAmountVatExcludedInCents?: number | null, draftAmountVatIncludedInCents?: number | null, draftDescription?: string | null, draftTitle?: string | null, draftVatRate?: number | null, createdBy: { __typename?: 'User', userId: string, firstname: string, lastname: string, picture: string }, notes?: Array<{ __typename?: 'SupplierBillingAdjustmentNote', content: string, createdAt?: string | null, createdById: string, id: string, supplierBillingAdjustmentId: string, createdBy: { __typename?: 'User', userId: string, firstname: string, lastname: string, picture: string } }> }
    | { __typename: 'SupplierBillingAdjustmentValidated', amountVatExcludedInCents: number, amountVatIncludedInCents: number, chargedTo: SupplierBillingAdjustmentChargeTo, createdAt: string, deletedAt?: string | null, description: string, documents: Array<string>, supplierBillingAdjustmentId: string, title: string, updatedAt: string, validatedAt: string, vatRate: number, createdBy: { __typename?: 'User', userId: string, firstname: string, lastname: string }, notes?: Array<{ __typename?: 'SupplierBillingAdjustmentNote', content: string, createdAt?: string | null, createdById: string, id: string, supplierBillingAdjustmentId: string, createdBy: { __typename?: 'User', userId: string, firstname: string, lastname: string, picture: string } }>, validatedBy: { __typename?: 'User', userId: string, firstname: string, lastname: string } }
   | null };

export type SupplierBillingAdjustmentsQueryVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type SupplierBillingAdjustmentsQuery = { __typename?: 'Query', supplierBillingAdjustments: Array<
    | { __typename: 'SupplierBillingAdjustmentDraft', chargedTo: SupplierBillingAdjustmentChargeTo, createdAt: string, deletedAt?: string | null, documents: Array<string>, supplierBillingAdjustmentId: string, updatedAt: string, draftAmountVatExcludedInCents?: number | null, draftAmountVatIncludedInCents?: number | null, draftDescription?: string | null, draftTitle?: string | null, draftVatRate?: number | null, createdBy: { __typename?: 'User', userId: string, firstname: string, lastname: string, picture: string } }
    | { __typename: 'SupplierBillingAdjustmentValidated', amountVatExcludedInCents: number, amountVatIncludedInCents: number, chargedTo: SupplierBillingAdjustmentChargeTo, createdAt: string, deletedAt?: string | null, description: string, documents: Array<string>, supplierBillingAdjustmentId: string, title: string, updatedAt: string, validatedAt: string, vatRate: number, createdBy: { __typename?: 'User', userId: string, firstname: string, lastname: string }, validatedBy: { __typename?: 'User', userId: string, firstname: string, lastname: string } }
  > };

export type UsedCouriersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsedCouriersQuery = { __typename?: 'Query', usedCouriers: Array<{ __typename?: 'Courier', supportedCountries: Array<string>, logoUrl: string, name: string, slug: string }> };

export type AcceptOrderClaimWithRefundMutationVariables = Exact<{
  input: AcceptOrderClaimWithRefundInput;
}>;


export type AcceptOrderClaimWithRefundMutation = { __typename?: 'Mutation', acceptOrderClaimWithRefund?: any | null };

export type AcceptOrderClaimWithReshipMutationVariables = Exact<{
  input: AcceptOrderClaimWithReshipInput;
}>;


export type AcceptOrderClaimWithReshipMutation = { __typename?: 'Mutation', acceptOrderClaimWithReship?: any | null };

export type AcceptOrderClaimWithVoucherReplacementCodesMutationVariables = Exact<{
  input: AcceptOrderClaimWithVoucherReplacementCodesInput;
}>;


export type AcceptOrderClaimWithVoucherReplacementCodesMutation = { __typename?: 'Mutation', acceptOrderClaimWithVoucherReplacementCodes?: any | null };

export type AcceptOrderClaimWithVoucherReplacementMessageMutationVariables = Exact<{
  input: AcceptOrderClaimWithVoucherReplacementMessageInput;
}>;


export type AcceptOrderClaimWithVoucherReplacementMessageMutation = { __typename?: 'Mutation', acceptOrderClaimWithVoucherReplacementMessage?: any | null };

export type ChangePasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: string | null };

export type CreateOrderParcelMutationVariables = Exact<{
  input: CreateOrderParcelInput;
}>;


export type CreateOrderParcelMutation = { __typename?: 'Mutation', createOrderParcel?: any | null };

export type CreateSupplierBillingAdjustmentMutationVariables = Exact<{
  input: CreateSupplierBillingAdjustmentInput;
}>;


export type CreateSupplierBillingAdjustmentMutation = { __typename?: 'Mutation', createSupplierBillingAdjustment?: any | null };

export type CreateSupplierBillingAdjustmentNoteMutationVariables = Exact<{
  supplierBillingAdjustmentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type CreateSupplierBillingAdjustmentNoteMutation = { __typename?: 'Mutation', createSupplierBillingAdjustmentNote?: any | null };

export type CreatePasswordConnectionMutationVariables = Exact<{
  userInfo: UserPasswordConnection;
}>;


export type CreatePasswordConnectionMutation = { __typename?: 'Mutation', createPasswordConnection?: string | null };

export type DeleteSupplierBillingAdjustmentMutationVariables = Exact<{
  supplierBillingAdjustmentId: Scalars['ID']['input'];
}>;


export type DeleteSupplierBillingAdjustmentMutation = { __typename?: 'Mutation', deleteSupplierBillingAdjustment?: any | null };

export type DeleteSupplierBillingAdjustmentNoteMutationVariables = Exact<{
  supplierBillingAdjustmentNoteId: Scalars['ID']['input'];
}>;


export type DeleteSupplierBillingAdjustmentNoteMutation = { __typename?: 'Mutation', deleteSupplierBillingAdjustmentNote?: any | null };

export type DetachBrandUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DetachBrandUserMutation = { __typename?: 'Mutation', detachBrandUser?: string | null };

export type EditBasicUserInfoMutationVariables = Exact<{
  basicUserInfo: BasicUserInfo;
}>;


export type EditBasicUserInfoMutation = { __typename?: 'Mutation', editBasicUserInfo?: string | null };

export type GenerateInvoiceUploadUrlMutationVariables = Exact<{
  saleId: Scalars['ID']['input'];
  upload: UploadInput;
}>;


export type GenerateInvoiceUploadUrlMutation = { __typename?: 'Mutation', generateInvoiceUploadUrl: { __typename?: 'Upload', expiresAt: string, key: string, url: string } };

export type GenerateProfilePictureUploadUrlMutationVariables = Exact<{
  upload: UploadInput;
}>;


export type GenerateProfilePictureUploadUrlMutation = { __typename?: 'Mutation', generateProfilePictureUploadUrl: { __typename?: 'Upload', expiresAt: string, key: string, url: string } };

export type GenerateSupplierBillingAdjusmentDocumentUploadUrlMutationVariables = Exact<{
  saleId: Scalars['ID']['input'];
  upload: UploadInput;
}>;


export type GenerateSupplierBillingAdjusmentDocumentUploadUrlMutation = { __typename?: 'Mutation', generateSupplierBillingAdjusmentDocumentUploadUrl: { __typename?: 'Upload', expiresAt: string, key: string, url: string } };

export type GroupOrderParcelMutationVariables = Exact<{
  input: GroupOrderParcelInput;
}>;


export type GroupOrderParcelMutation = { __typename?: 'Mutation', groupOrderParcel?: any | null };

export type GenerateInvoiceCustomsMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GenerateInvoiceCustomsMutation = { __typename?: 'Mutation', generateInvoiceCustoms: { __typename?: 'GenerateInvoiceCustoms', url: string } };

export type GeneratePurchaseOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GeneratePurchaseOrderMutation = { __typename?: 'Mutation', generatePurchaseOrder: { __typename?: 'GeneratePurchaseOrder', url: string } };

export type JoinBrandMutationVariables = Exact<{
  brandId: Scalars['String']['input'];
  inviteCode: Scalars['String']['input'];
}>;


export type JoinBrandMutation = { __typename?: 'Mutation', joinBrand?: string | null };

export type PostRegisterMutationVariables = Exact<{
  config: PostRegisterConfig;
}>;


export type PostRegisterMutation = { __typename?: 'Mutation', postRegister?: PostRegisterResult | null };

export type SetStockMutationVariables = Exact<{
  input: SetStockInput;
}>;


export type SetStockMutation = { __typename?: 'Mutation', setStock?: SetStockErrorCode | null };

export type SetUserRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  role: BrandRole;
}>;


export type SetUserRoleMutation = { __typename?: 'Mutation', setUserRole?: any | null };

export type SubmitDownPaymentMutationVariables = Exact<{
  input: SubmitDownPaymentInput;
  saleId: Scalars['ID']['input'];
}>;


export type SubmitDownPaymentMutation = { __typename?: 'Mutation', submitDownPayment?: any | null };

export type SubmitInvoiceMutationVariables = Exact<{
  input: SubmitInvoiceInput;
  saleId: Scalars['ID']['input'];
}>;


export type SubmitInvoiceMutation = { __typename?: 'Mutation', submitInvoice?: any | null };

export type SwapOrderParcelMutationVariables = Exact<{
  input: SwapOrderParcelInput;
}>;


export type SwapOrderParcelMutation = { __typename?: 'Mutation', swapOrderParcel?: any | null };

export type ValidateSupplierBillingAdjustmentMutationVariables = Exact<{
  supplierBillingAdjustmentId: Scalars['ID']['input'];
}>;


export type ValidateSupplierBillingAdjustmentMutation = { __typename?: 'Mutation', validateSupplierBillingAdjustment?: any | null };

export type UpdateInviteCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateInviteCodeMutation = { __typename?: 'Mutation', updateInviteCode: string };

export type UpdateOrderParcelMutationVariables = Exact<{
  input: UpdateOrderParcelInput;
}>;


export type UpdateOrderParcelMutation = { __typename?: 'Mutation', updateOrderParcel?: any | null };

export type UpdateProfilePictureMutationVariables = Exact<{
  url: Scalars['BaseUrl']['input'];
}>;


export type UpdateProfilePictureMutation = { __typename?: 'Mutation', updateProfilePicture?: any | null };

export type UpdateSupplierBillingAdjustmentMutationVariables = Exact<{
  input: UpdateSupplierBillingAdjustmentInput;
}>;


export type UpdateSupplierBillingAdjustmentMutation = { __typename?: 'Mutation', updateSupplierBillingAdjustment?: any | null };

export type UpdateUserLanguageMutationVariables = Exact<{
  preferredLanguage: Scalars['String']['input'];
}>;


export type UpdateUserLanguageMutation = { __typename?: 'Mutation', updateUserLanguage?: string | null };

export type ProductsUpdatedSubscriptionVariables = Exact<{
  saleId: Scalars['ID']['input'];
}>;


export type ProductsUpdatedSubscription = { __typename?: 'Subscription', productsUpdated: Array<{ __typename?: 'Product', id: string, variants: Array<{ __typename?: 'ProductVariant', id: string, stock: { __typename?: 'Stock', id: string, quantity: number }, stockAlertsSummary: { __typename?: 'StockAlertsSummary', activeAlertsCount: number, archivedAlertsCount: number, potentialRevenue: number } }> }> };

export type ShopifyInstalledSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ShopifyInstalledSubscription = { __typename?: 'Subscription', shopifyInstalled: string };


export const PartialCourierFragmentDoc = `
    fragment PartialCourier on Courier {
  logoUrl
  name
  slug
}
    `;
export const PartialOrderFragmentDoc = `
    fragment PartialOrder on Order {
  claims {
    createdAt
  }
  createdAt
  hasSynchronizationError
  id
  items {
    imageUrl
  }
  parcels {
    hasTrackingStucked
    trackingSubStatus
  }
  recipient {
    fullName
  }
  tags {
    brand
    claim
    claimReason
    fulfillment
    refund
    reship
    return
    shipment
    shopify
  }
  totalPriceSold {
    valueWithVat
    valueWithoutVat
    currency
  }
}
    `;
export const PartialSupplierBillingAdjustmentFragmentDoc = `
    fragment PartialSupplierBillingAdjustment on SupplierBillingAdjustment {
  ... on SupplierBillingAdjustmentDraft {
    __typename
    draftAmountVatExcludedInCents: amountVatExcludedInCents
    draftAmountVatIncludedInCents: amountVatIncludedInCents
    chargedTo
    createdAt
    createdBy {
      userId
      firstname
      lastname
      picture
    }
    deletedAt
    draftDescription: description
    documents
    supplierBillingAdjustmentId
    draftTitle: title
    updatedAt
    draftVatRate: vatRate
  }
  ... on SupplierBillingAdjustmentValidated {
    __typename
    amountVatExcludedInCents
    amountVatIncludedInCents
    chargedTo
    createdAt
    createdBy {
      userId
      firstname
      lastname
    }
    deletedAt
    description
    documents
    supplierBillingAdjustmentId
    title
    updatedAt
    validatedAt
    validatedBy {
      userId
      firstname
      lastname
    }
    vatRate
  }
}
    `;
export const CurrentUserDocument = `
    query currentUser {
  currentUser {
    userId
    intercomUserHash
  }
}
    `;

export const useCurrentUserQuery = <
      TData = CurrentUserQuery,
      TError = unknown
    >(
      variables?: CurrentUserQueryVariables,
      options?: Omit<UseQueryOptions<CurrentUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CurrentUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CurrentUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['currentUser'] : ['currentUser', variables],
    queryFn: useFetchData<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument).bind(null, variables),
    ...options
  }
    )};

useCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) => variables === undefined ? ['currentUser'] : ['currentUser', variables];

export const useInfiniteCurrentUserQuery = <
      TData = InfiniteData<CurrentUserQuery>,
      TError = unknown
    >(
      variables: CurrentUserQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CurrentUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CurrentUserQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument)
    return useInfiniteQuery<CurrentUserQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['currentUser.infinite'] : ['currentUser.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) => variables === undefined ? ['currentUser.infinite'] : ['currentUser.infinite', variables];

export const BillingDocument = `
    query billing($saleId: ID!) {
  billingV2(saleId: $saleId) {
    adjustments {
      ... on SupplierBillingAdjustmentDraft {
        __typename
      }
      ... on SupplierBillingAdjustmentValidated {
        __typename
        amountVatExcludedInCents
        amountVatIncludedInCents
        chargedTo
        supplierBillingAdjustmentId
        title
        vatRate
      }
    }
    agg_by_vat_rate {
      vat_rate
      total_operation_ht
      total_operation_ttc
      total_commission_ht
      total_commission_ttc
      total_billing_ht
      total_billing_ttc
      total_vat
    }
    down_payment {
      __typename
      ... on DownPaymentClassic {
        financialDetail {
          agg_by_vat_rate {
            vat_rate
            total_operation_ht
            total_operation_ttc
            total_commission_ht
            total_commission_ttc
            total_billing_ht
            total_billing_ttc
            total_vat
          }
          total_billing_ht
          total_billing_ttc
          total_commission_ht
          total_commission_ttc
          total_delivery_ht
          total_delivery_ttc
          total_operation_ht
          total_operation_ttc
          total_refund_ht
          total_refund_ttc
          total_remaining_ht
          total_remaining_ttc
        }
        preset
        rate
        rules {
          __typename
          ... on ActivationDateRule {
            activationDate
            isValidated
          }
          ... on FulfilledOrderPercentageRule {
            currentValue
            isValidated
            targetValue
          }
          ... on MinimumAmountInCentsRule {
            currentValue
            isValidated
            targetValue
          }
        }
      }
      ... on DownPaymentExceptional {
        preset
      }
    }
    errors {
      __typename
      id
      order_id
      product_id
      code
    }
    has_error
    is_subject_to_vat
    is_full_paid
    payments {
      amountVatExcludedInCents
      amountVatInCents
      amountVatIncludedInCents
      invoiceId
      paidAt
    }
    total_adjustment_ht
    total_billing_ht
    total_billing_ttc
    total_commission_ht
    total_commission_ttc
    total_delivery_ht
    total_delivery_ttc
    total_operation_ht
    total_operation_ttc
    total_refund_ht
    total_refund_ttc
    total_remaining_ht
    total_remaining_ttc
    total_eee_price_ttc
    total_eee_price_ht
  }
}
    `;

export const useBillingQuery = <
      TData = BillingQuery,
      TError = unknown
    >(
      variables: BillingQueryVariables,
      options?: Omit<UseQueryOptions<BillingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BillingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BillingQuery, TError, TData>(
      {
    queryKey: ['billing', variables],
    queryFn: useFetchData<BillingQuery, BillingQueryVariables>(BillingDocument).bind(null, variables),
    ...options
  }
    )};

useBillingQuery.getKey = (variables: BillingQueryVariables) => ['billing', variables];

export const useInfiniteBillingQuery = <
      TData = InfiniteData<BillingQuery>,
      TError = unknown
    >(
      variables: BillingQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BillingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BillingQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BillingQuery, BillingQueryVariables>(BillingDocument)
    return useInfiniteQuery<BillingQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['billing.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBillingQuery.getKey = (variables: BillingQueryVariables) => ['billing.infinite', variables];

export const BillingExportDocument = `
    query billingExport($saleId: ID!, $input: BillingExportInput!) {
  billingExport(saleId: $saleId, input: $input) {
    fileUrl
  }
}
    `;

export const useBillingExportQuery = <
      TData = BillingExportQuery,
      TError = unknown
    >(
      variables: BillingExportQueryVariables,
      options?: Omit<UseQueryOptions<BillingExportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BillingExportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BillingExportQuery, TError, TData>(
      {
    queryKey: ['billingExport', variables],
    queryFn: useFetchData<BillingExportQuery, BillingExportQueryVariables>(BillingExportDocument).bind(null, variables),
    ...options
  }
    )};

useBillingExportQuery.getKey = (variables: BillingExportQueryVariables) => ['billingExport', variables];

export const useInfiniteBillingExportQuery = <
      TData = InfiniteData<BillingExportQuery>,
      TError = unknown
    >(
      variables: BillingExportQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BillingExportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BillingExportQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BillingExportQuery, BillingExportQueryVariables>(BillingExportDocument)
    return useInfiniteQuery<BillingExportQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['billingExport.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBillingExportQuery.getKey = (variables: BillingExportQueryVariables) => ['billingExport.infinite', variables];

export const BillingStateDocument = `
    query billingState($saleId: ID!) {
  supplierBillingState(saleId: $saleId) {
    canAccess
    canAccessBypassed
    isPendingClaimClosing
    isPendingOrderDelivery
    isPendingReturnValidation
    isPendingWithdrawalPeriod
    pendingClaimClosingOrderIds
    pendingOrderDeliveryOrderIds
    pendingReturnValidationOrderIds
    saleStatus
    withdrawalPeriodEndDate
    withdrawalPeriodInDays
  }
}
    `;

export const useBillingStateQuery = <
      TData = BillingStateQuery,
      TError = unknown
    >(
      variables: BillingStateQueryVariables,
      options?: Omit<UseQueryOptions<BillingStateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BillingStateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BillingStateQuery, TError, TData>(
      {
    queryKey: ['billingState', variables],
    queryFn: useFetchData<BillingStateQuery, BillingStateQueryVariables>(BillingStateDocument).bind(null, variables),
    ...options
  }
    )};

useBillingStateQuery.getKey = (variables: BillingStateQueryVariables) => ['billingState', variables];

export const useInfiniteBillingStateQuery = <
      TData = InfiniteData<BillingStateQuery>,
      TError = unknown
    >(
      variables: BillingStateQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BillingStateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BillingStateQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BillingStateQuery, BillingStateQueryVariables>(BillingStateDocument)
    return useInfiniteQuery<BillingStateQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['billingState.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBillingStateQuery.getKey = (variables: BillingStateQueryVariables) => ['billingState.infinite', variables];

export const BrandInfoDocument = `
    query brandInfo($brandId: String!) {
  brandInfo(brandId: $brandId) {
    name
    acceptContract
    nbUsers
  }
}
    `;

export const useBrandInfoQuery = <
      TData = BrandInfoQuery,
      TError = unknown
    >(
      variables: BrandInfoQueryVariables,
      options?: Omit<UseQueryOptions<BrandInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandInfoQuery, TError, TData>(
      {
    queryKey: ['brandInfo', variables],
    queryFn: useFetchData<BrandInfoQuery, BrandInfoQueryVariables>(BrandInfoDocument).bind(null, variables),
    ...options
  }
    )};

useBrandInfoQuery.getKey = (variables: BrandInfoQueryVariables) => ['brandInfo', variables];

export const useInfiniteBrandInfoQuery = <
      TData = InfiniteData<BrandInfoQuery>,
      TError = unknown
    >(
      variables: BrandInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BrandInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BrandInfoQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BrandInfoQuery, BrandInfoQueryVariables>(BrandInfoDocument)
    return useInfiniteQuery<BrandInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['brandInfo.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBrandInfoQuery.getKey = (variables: BrandInfoQueryVariables) => ['brandInfo.infinite', variables];

export const BrandsAccessDocument = `
    query brandsAccess {
  getBrandsAccess {
    brandId
    brandName
    role
    store
  }
}
    `;

export const useBrandsAccessQuery = <
      TData = BrandsAccessQuery,
      TError = unknown
    >(
      variables?: BrandsAccessQueryVariables,
      options?: Omit<UseQueryOptions<BrandsAccessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BrandsAccessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BrandsAccessQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['brandsAccess'] : ['brandsAccess', variables],
    queryFn: useFetchData<BrandsAccessQuery, BrandsAccessQueryVariables>(BrandsAccessDocument).bind(null, variables),
    ...options
  }
    )};

useBrandsAccessQuery.getKey = (variables?: BrandsAccessQueryVariables) => variables === undefined ? ['brandsAccess'] : ['brandsAccess', variables];

export const useInfiniteBrandsAccessQuery = <
      TData = InfiniteData<BrandsAccessQuery>,
      TError = unknown
    >(
      variables: BrandsAccessQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BrandsAccessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BrandsAccessQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<BrandsAccessQuery, BrandsAccessQueryVariables>(BrandsAccessDocument)
    return useInfiniteQuery<BrandsAccessQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['brandsAccess.infinite'] : ['brandsAccess.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteBrandsAccessQuery.getKey = (variables?: BrandsAccessQueryVariables) => variables === undefined ? ['brandsAccess.infinite'] : ['brandsAccess.infinite', variables];

export const SearchCouriersDocument = `
    query searchCouriers($input: SearchCouriersInput!) {
  searchCouriers(input: $input) {
    ...PartialCourier
    supportedCountries
  }
}
    ${PartialCourierFragmentDoc}`;

export const useSearchCouriersQuery = <
      TData = SearchCouriersQuery,
      TError = unknown
    >(
      variables: SearchCouriersQueryVariables,
      options?: Omit<UseQueryOptions<SearchCouriersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchCouriersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchCouriersQuery, TError, TData>(
      {
    queryKey: ['searchCouriers', variables],
    queryFn: useFetchData<SearchCouriersQuery, SearchCouriersQueryVariables>(SearchCouriersDocument).bind(null, variables),
    ...options
  }
    )};

useSearchCouriersQuery.getKey = (variables: SearchCouriersQueryVariables) => ['searchCouriers', variables];

export const useInfiniteSearchCouriersQuery = <
      TData = InfiniteData<SearchCouriersQuery>,
      TError = unknown
    >(
      variables: SearchCouriersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchCouriersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchCouriersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchCouriersQuery, SearchCouriersQueryVariables>(SearchCouriersDocument)
    return useInfiniteQuery<SearchCouriersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchCouriers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchCouriersQuery.getKey = (variables: SearchCouriersQueryVariables) => ['searchCouriers.infinite', variables];

export const SearchCouriersBySupportedCountriesDocument = `
    query searchCouriersBySupportedCountries($input: SearchCouriersBySupportedCountries!) {
  searchCouriersBySupportedCountries(input: $input) {
    ...PartialCourier
    supportedCountries
  }
}
    ${PartialCourierFragmentDoc}`;

export const useSearchCouriersBySupportedCountriesQuery = <
      TData = SearchCouriersBySupportedCountriesQuery,
      TError = unknown
    >(
      variables: SearchCouriersBySupportedCountriesQueryVariables,
      options?: Omit<UseQueryOptions<SearchCouriersBySupportedCountriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchCouriersBySupportedCountriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchCouriersBySupportedCountriesQuery, TError, TData>(
      {
    queryKey: ['searchCouriersBySupportedCountries', variables],
    queryFn: useFetchData<SearchCouriersBySupportedCountriesQuery, SearchCouriersBySupportedCountriesQueryVariables>(SearchCouriersBySupportedCountriesDocument).bind(null, variables),
    ...options
  }
    )};

useSearchCouriersBySupportedCountriesQuery.getKey = (variables: SearchCouriersBySupportedCountriesQueryVariables) => ['searchCouriersBySupportedCountries', variables];

export const useInfiniteSearchCouriersBySupportedCountriesQuery = <
      TData = InfiniteData<SearchCouriersBySupportedCountriesQuery>,
      TError = unknown
    >(
      variables: SearchCouriersBySupportedCountriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchCouriersBySupportedCountriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchCouriersBySupportedCountriesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SearchCouriersBySupportedCountriesQuery, SearchCouriersBySupportedCountriesQueryVariables>(SearchCouriersBySupportedCountriesDocument)
    return useInfiniteQuery<SearchCouriersBySupportedCountriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['searchCouriersBySupportedCountries.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchCouriersBySupportedCountriesQuery.getKey = (variables: SearchCouriersBySupportedCountriesQueryVariables) => ['searchCouriersBySupportedCountries.infinite', variables];

export const DetectCouriersDocument = `
    query detectCouriers($input: DetectCouriersInput!) {
  detectCouriers(input: $input) {
    logoUrl
    name
    slug
  }
}
    `;

export const useDetectCouriersQuery = <
      TData = DetectCouriersQuery,
      TError = unknown
    >(
      variables: DetectCouriersQueryVariables,
      options?: Omit<UseQueryOptions<DetectCouriersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DetectCouriersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DetectCouriersQuery, TError, TData>(
      {
    queryKey: ['detectCouriers', variables],
    queryFn: useFetchData<DetectCouriersQuery, DetectCouriersQueryVariables>(DetectCouriersDocument).bind(null, variables),
    ...options
  }
    )};

useDetectCouriersQuery.getKey = (variables: DetectCouriersQueryVariables) => ['detectCouriers', variables];

export const useInfiniteDetectCouriersQuery = <
      TData = InfiniteData<DetectCouriersQuery>,
      TError = unknown
    >(
      variables: DetectCouriersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DetectCouriersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DetectCouriersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<DetectCouriersQuery, DetectCouriersQueryVariables>(DetectCouriersDocument)
    return useInfiniteQuery<DetectCouriersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['detectCouriers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDetectCouriersQuery.getKey = (variables: DetectCouriersQueryVariables) => ['detectCouriers.infinite', variables];

export const InviteCodeDocument = `
    query inviteCode {
  getInviteCode
}
    `;

export const useInviteCodeQuery = <
      TData = InviteCodeQuery,
      TError = unknown
    >(
      variables?: InviteCodeQueryVariables,
      options?: Omit<UseQueryOptions<InviteCodeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InviteCodeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InviteCodeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['inviteCode'] : ['inviteCode', variables],
    queryFn: useFetchData<InviteCodeQuery, InviteCodeQueryVariables>(InviteCodeDocument).bind(null, variables),
    ...options
  }
    )};

useInviteCodeQuery.getKey = (variables?: InviteCodeQueryVariables) => variables === undefined ? ['inviteCode'] : ['inviteCode', variables];

export const useInfiniteInviteCodeQuery = <
      TData = InfiniteData<InviteCodeQuery>,
      TError = unknown
    >(
      variables: InviteCodeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<InviteCodeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<InviteCodeQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<InviteCodeQuery, InviteCodeQueryVariables>(InviteCodeDocument)
    return useInfiniteQuery<InviteCodeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['inviteCode.infinite'] : ['inviteCode.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteInviteCodeQuery.getKey = (variables?: InviteCodeQueryVariables) => variables === undefined ? ['inviteCode.infinite'] : ['inviteCode.infinite', variables];

export const InfoDocument = `
    query info {
  info {
    version
    environment
  }
}
    `;

export const useInfoQuery = <
      TData = InfoQuery,
      TError = unknown
    >(
      variables?: InfoQueryVariables,
      options?: Omit<UseQueryOptions<InfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InfoQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['info'] : ['info', variables],
    queryFn: useFetchData<InfoQuery, InfoQueryVariables>(InfoDocument).bind(null, variables),
    ...options
  }
    )};

useInfoQuery.getKey = (variables?: InfoQueryVariables) => variables === undefined ? ['info'] : ['info', variables];

export const useInfiniteInfoQuery = <
      TData = InfiniteData<InfoQuery>,
      TError = unknown
    >(
      variables: InfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<InfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<InfoQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<InfoQuery, InfoQueryVariables>(InfoDocument)
    return useInfiniteQuery<InfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['info.infinite'] : ['info.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteInfoQuery.getKey = (variables?: InfoQueryVariables) => variables === undefined ? ['info.infinite'] : ['info.infinite', variables];

export const InvoicesDocument = `
    query invoices($saleId: ID!) {
  invoices(saleId: $saleId) {
    createdAt
    fileName
    fileUrl
    id
    status
    type
  }
}
    `;

export const useInvoicesQuery = <
      TData = InvoicesQuery,
      TError = unknown
    >(
      variables: InvoicesQueryVariables,
      options?: Omit<UseQueryOptions<InvoicesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<InvoicesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<InvoicesQuery, TError, TData>(
      {
    queryKey: ['invoices', variables],
    queryFn: useFetchData<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument).bind(null, variables),
    ...options
  }
    )};

useInvoicesQuery.getKey = (variables: InvoicesQueryVariables) => ['invoices', variables];

export const useInfiniteInvoicesQuery = <
      TData = InfiniteData<InvoicesQuery>,
      TError = unknown
    >(
      variables: InvoicesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<InvoicesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<InvoicesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument)
    return useInfiniteQuery<InvoicesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['invoices.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteInvoicesQuery.getKey = (variables: InvoicesQueryVariables) => ['invoices.infinite', variables];

export const JoinOrderReturnLabelForClaimDocument = `
    mutation joinOrderReturnLabelForClaim($input: JoinOrderReturnLabelForClaimInput!) {
  joinOrderReturnLabelForClaim(input: $input)
}
    `;

export const useJoinOrderReturnLabelForClaimMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<JoinOrderReturnLabelForClaimMutation, TError, JoinOrderReturnLabelForClaimMutationVariables, TContext>) => {
    
    return useMutation<JoinOrderReturnLabelForClaimMutation, TError, JoinOrderReturnLabelForClaimMutationVariables, TContext>(
      {
    mutationKey: ['joinOrderReturnLabelForClaim'],
    mutationFn: useFetchData<JoinOrderReturnLabelForClaimMutation, JoinOrderReturnLabelForClaimMutationVariables>(JoinOrderReturnLabelForClaimDocument),
    ...options
  }
    )};

export const MembersDocument = `
    query members {
  members {
    userId
    email
    role
    picture
    firstname
    lastname
  }
}
    `;

export const useMembersQuery = <
      TData = MembersQuery,
      TError = unknown
    >(
      variables?: MembersQueryVariables,
      options?: Omit<UseQueryOptions<MembersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<MembersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<MembersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['members'] : ['members', variables],
    queryFn: useFetchData<MembersQuery, MembersQueryVariables>(MembersDocument).bind(null, variables),
    ...options
  }
    )};

useMembersQuery.getKey = (variables?: MembersQueryVariables) => variables === undefined ? ['members'] : ['members', variables];

export const useInfiniteMembersQuery = <
      TData = InfiniteData<MembersQuery>,
      TError = unknown
    >(
      variables: MembersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<MembersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<MembersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<MembersQuery, MembersQueryVariables>(MembersDocument)
    return useInfiniteQuery<MembersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['members.infinite'] : ['members.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteMembersQuery.getKey = (variables?: MembersQueryVariables) => variables === undefined ? ['members.infinite'] : ['members.infinite', variables];

export const OrderDocument = `
    query order($orderId: ID!) {
  order(id: $orderId) {
    billingId
    claims {
      acceptedMessage
      actionFromSeller
      createdAt
      id
      isAccepted
      isDeclined
      items {
        digitalCouponCode
        gtin
        id
        imageUrl
        isDigital
        isOffered
        isReturnable
        isReturnGenerated
        name
        newDigitalCouponCode
        priceSold {
          currency
          valueWithVat
          valueWithoutVat
        }
        productId
        productVariantId
        size
        sku
      }
      messageFromSupport
      otherReasonLabel
      preferredSolution
      proofUrls
      reason
      reshipActionErrorReasons
      swornStatementUrls
    }
    createdAt
    customerId
    hasBeenExported
    id
    initialOrderId
    integration {
      errorMessage
      shopify {
        orderCountId
        orderId
        orderUrl
      }
    }
    isShippingEstimatedTimeExceeded
    isCancelled
    isFullDigital
    items {
      digitalCouponCode
      gtin
      id
      imageUrl
      isCancelled
      isDigital
      isOffered
      isReturnGenerated
      isReturnValidated
      name
      newDigitalCouponCode
      size
      sku
      priceSold {
        currency
        valueWithVat
        valueWithoutVat
      }
      productId
      productVariantId
      refundSummary {
        isTotallyRefunded
        refundedAmountInPercentage
        refundedAmountInPercentageCoveredByChoose
        refundedAmountInPercentageCoveredBySupplier
      }
      returnReasonCode
      returnSubReasonCode
    }
    linesRefunds {
      amountInCents
      coveredBy
      createdAt
      id
      lineId
      lineType
      reason
    }
    parcels {
      estimatedDeliveryDateRange {
        max
        min
      }
      hasTrackingStucked
      id
      items {
        digitalCouponCode
        gtin
        name
        newDigitalCouponCode
        id
        imageUrl
        isDigital
        isOffered
        isReturnGenerated
        priceSold {
          currency
          valueWithVat
          valueWithoutVat
        }
        productId
        productVariantId
        size
        sku
      }
      recipient {
        address {
          street
          streetAdditional
          zipCode
          city
          county
          state
          country
          countryCode
        }
        email
        firstName
        fullName
        lastName
        phoneNumber
      }
      trackingCourier {
        ...PartialCourier
      }
      trackingDeliveredAt
      trackingNumber
      trackingStatus
      trackingSubStatus
      trackingUrl
      trackingUpdatedAt
    }
    rating {
      rate
      message
    }
    recipient {
      id
      fullName
      firstName
      lastName
      email
      phoneNumber
      address {
        street
        streetAdditional
        zipCode
        city
        county
        state
        country
        countryCode
      }
      previous {
        fullName
        firstName
        lastName
        email
        phoneNumber
        address {
          street
          streetAdditional
          zipCode
          city
          county
          state
          country
          countryCode
        }
      }
    }
    reshipOrderId
    reshipOrder {
      createdAt
    }
    returns {
      createdAt
      claimId
      id
      lines {
        item {
          digitalCouponCode
          gtin
          id
          imageUrl
          isDigital
          isOffered
          isReturnGenerated
          newDigitalCouponCode
          name
          priceSold {
            currency
            valueWithVat
            valueWithoutVat
          }
          productId
          productVariantId
          size
          sku
        }
      }
      tracking {
        courier {
          ...PartialCourier
        }
        deliveredAt
        number
        status
        updatedAt
        url
      }
    }
    saleId
    sellerId
    shipping {
      fees
      feesSold
      deliveryDateRangeHistory {
        start
        end
      }
      policyId
      pickupPoint {
        id
        countryCode
        network
        address {
          name
          street
          streetAdditional
          zipCode
          city
          countryCode
        }
      }
    }
    tags {
      claim
      fulfillment
      refund
      reship
      return
      shipment
    }
    totalPriceSold {
      currency
      valueWithVat
      valueWithoutVat
    }
  }
}
    ${PartialCourierFragmentDoc}`;

export const useOrderQuery = <
      TData = OrderQuery,
      TError = unknown
    >(
      variables: OrderQueryVariables,
      options?: Omit<UseQueryOptions<OrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderQuery, TError, TData>(
      {
    queryKey: ['order', variables],
    queryFn: useFetchData<OrderQuery, OrderQueryVariables>(OrderDocument).bind(null, variables),
    ...options
  }
    )};

useOrderQuery.getKey = (variables: OrderQueryVariables) => ['order', variables];

export const useInfiniteOrderQuery = <
      TData = InfiniteData<OrderQuery>,
      TError = unknown
    >(
      variables: OrderQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrderQuery, OrderQueryVariables>(OrderDocument)
    return useInfiniteQuery<OrderQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['order.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderQuery.getKey = (variables: OrderQueryVariables) => ['order.infinite', variables];

export const OrderReturnLabelUploadUrlDocument = `
    query orderReturnLabelUploadUrl($input: OrderReturnLabelUploadUrlInput!) {
  orderReturnLabelUploadUrl(input: $input) {
    expiresAt
    key
    url
  }
}
    `;

export const useOrderReturnLabelUploadUrlQuery = <
      TData = OrderReturnLabelUploadUrlQuery,
      TError = unknown
    >(
      variables: OrderReturnLabelUploadUrlQueryVariables,
      options?: Omit<UseQueryOptions<OrderReturnLabelUploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrderReturnLabelUploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrderReturnLabelUploadUrlQuery, TError, TData>(
      {
    queryKey: ['orderReturnLabelUploadUrl', variables],
    queryFn: useFetchData<OrderReturnLabelUploadUrlQuery, OrderReturnLabelUploadUrlQueryVariables>(OrderReturnLabelUploadUrlDocument).bind(null, variables),
    ...options
  }
    )};

useOrderReturnLabelUploadUrlQuery.getKey = (variables: OrderReturnLabelUploadUrlQueryVariables) => ['orderReturnLabelUploadUrl', variables];

export const useInfiniteOrderReturnLabelUploadUrlQuery = <
      TData = InfiniteData<OrderReturnLabelUploadUrlQuery>,
      TError = unknown
    >(
      variables: OrderReturnLabelUploadUrlQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrderReturnLabelUploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrderReturnLabelUploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrderReturnLabelUploadUrlQuery, OrderReturnLabelUploadUrlQueryVariables>(OrderReturnLabelUploadUrlDocument)
    return useInfiniteQuery<OrderReturnLabelUploadUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['orderReturnLabelUploadUrl.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrderReturnLabelUploadUrlQuery.getKey = (variables: OrderReturnLabelUploadUrlQueryVariables) => ['orderReturnLabelUploadUrl.infinite', variables];

export const OrdersByTrackingDocument = `
    query ordersByTracking($input: OrdersByTrackingInput!) {
  ordersByTracking(input: $input) {
    id
    saleId
    customerId
    recipient {
      id
      email
      fullName
    }
    parcels {
      trackingCourier {
        ...PartialCourier
      }
      trackingNumber
    }
  }
}
    ${PartialCourierFragmentDoc}`;

export const useOrdersByTrackingQuery = <
      TData = OrdersByTrackingQuery,
      TError = unknown
    >(
      variables: OrdersByTrackingQueryVariables,
      options?: Omit<UseQueryOptions<OrdersByTrackingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrdersByTrackingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrdersByTrackingQuery, TError, TData>(
      {
    queryKey: ['ordersByTracking', variables],
    queryFn: useFetchData<OrdersByTrackingQuery, OrdersByTrackingQueryVariables>(OrdersByTrackingDocument).bind(null, variables),
    ...options
  }
    )};

useOrdersByTrackingQuery.getKey = (variables: OrdersByTrackingQueryVariables) => ['ordersByTracking', variables];

export const useInfiniteOrdersByTrackingQuery = <
      TData = InfiniteData<OrdersByTrackingQuery>,
      TError = unknown
    >(
      variables: OrdersByTrackingQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrdersByTrackingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrdersByTrackingQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrdersByTrackingQuery, OrdersByTrackingQueryVariables>(OrdersByTrackingDocument)
    return useInfiniteQuery<OrdersByTrackingQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ordersByTracking.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrdersByTrackingQuery.getKey = (variables: OrdersByTrackingQueryVariables) => ['ordersByTracking.infinite', variables];

export const OrdersLinkedDocument = `
    query ordersLinked($input: OrdersByTrackingInput!) {
  ordersByTracking(input: $input) {
    id
  }
}
    `;

export const useOrdersLinkedQuery = <
      TData = OrdersLinkedQuery,
      TError = unknown
    >(
      variables: OrdersLinkedQueryVariables,
      options?: Omit<UseQueryOptions<OrdersLinkedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrdersLinkedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrdersLinkedQuery, TError, TData>(
      {
    queryKey: ['ordersLinked', variables],
    queryFn: useFetchData<OrdersLinkedQuery, OrdersLinkedQueryVariables>(OrdersLinkedDocument).bind(null, variables),
    ...options
  }
    )};

useOrdersLinkedQuery.getKey = (variables: OrdersLinkedQueryVariables) => ['ordersLinked', variables];

export const useInfiniteOrdersLinkedQuery = <
      TData = InfiniteData<OrdersLinkedQuery>,
      TError = unknown
    >(
      variables: OrdersLinkedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrdersLinkedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrdersLinkedQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrdersLinkedQuery, OrdersLinkedQueryVariables>(OrdersLinkedDocument)
    return useInfiniteQuery<OrdersLinkedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ordersLinked.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrdersLinkedQuery.getKey = (variables: OrdersLinkedQueryVariables) => ['ordersLinked.infinite', variables];

export const PartialOrderDocument = `
    query partialOrder($orderId: ID!) {
  order(id: $orderId) {
    ...PartialOrder
  }
}
    ${PartialOrderFragmentDoc}`;

export const usePartialOrderQuery = <
      TData = PartialOrderQuery,
      TError = unknown
    >(
      variables: PartialOrderQueryVariables,
      options?: Omit<UseQueryOptions<PartialOrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<PartialOrderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<PartialOrderQuery, TError, TData>(
      {
    queryKey: ['partialOrder', variables],
    queryFn: useFetchData<PartialOrderQuery, PartialOrderQueryVariables>(PartialOrderDocument).bind(null, variables),
    ...options
  }
    )};

usePartialOrderQuery.getKey = (variables: PartialOrderQueryVariables) => ['partialOrder', variables];

export const useInfinitePartialOrderQuery = <
      TData = InfiniteData<PartialOrderQuery>,
      TError = unknown
    >(
      variables: PartialOrderQueryVariables,
      options: Omit<UseInfiniteQueryOptions<PartialOrderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<PartialOrderQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<PartialOrderQuery, PartialOrderQueryVariables>(PartialOrderDocument)
    return useInfiniteQuery<PartialOrderQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['partialOrder.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfinitePartialOrderQuery.getKey = (variables: PartialOrderQueryVariables) => ['partialOrder.infinite', variables];

export const ProductsDocument = `
    query products($saleId: ID!) {
  products(saleId: $saleId) {
    id
    name
    isDigital
    variants {
      id
      productId
      title
      sku
      gtin
      image
      stock {
        id
        quantity
      }
      stockAlertsSummary {
        activeAlertsCount
        archivedAlertsCount
        potentialRevenue
      }
    }
  }
}
    `;

export const useProductsQuery = <
      TData = ProductsQuery,
      TError = unknown
    >(
      variables: ProductsQueryVariables,
      options?: Omit<UseQueryOptions<ProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ProductsQuery, TError, TData>(
      {
    queryKey: ['products', variables],
    queryFn: useFetchData<ProductsQuery, ProductsQueryVariables>(ProductsDocument).bind(null, variables),
    ...options
  }
    )};

useProductsQuery.getKey = (variables: ProductsQueryVariables) => ['products', variables];

export const useInfiniteProductsQuery = <
      TData = InfiniteData<ProductsQuery>,
      TError = unknown
    >(
      variables: ProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ProductsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<ProductsQuery, ProductsQueryVariables>(ProductsDocument)
    return useInfiniteQuery<ProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['products.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteProductsQuery.getKey = (variables: ProductsQueryVariables) => ['products.infinite', variables];

export const OrdersDocument = `
    query orders($saleId: ID!, $input: OrdersInput!) {
  orders(saleId: $saleId, input: $input) {
    nodes {
      ...PartialOrder
    }
    totalCount
    paging {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
      pageSize
    }
  }
}
    ${PartialOrderFragmentDoc}`;

export const useOrdersQuery = <
      TData = OrdersQuery,
      TError = unknown
    >(
      variables: OrdersQueryVariables,
      options?: Omit<UseQueryOptions<OrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrdersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrdersQuery, TError, TData>(
      {
    queryKey: ['orders', variables],
    queryFn: useFetchData<OrdersQuery, OrdersQueryVariables>(OrdersDocument).bind(null, variables),
    ...options
  }
    )};

useOrdersQuery.getKey = (variables: OrdersQueryVariables) => ['orders', variables];

export const useInfiniteOrdersQuery = <
      TData = InfiniteData<OrdersQuery>,
      TError = unknown
    >(
      variables: OrdersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrdersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrdersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrdersQuery, OrdersQueryVariables>(OrdersDocument)
    return useInfiniteQuery<OrdersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['orders.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrdersQuery.getKey = (variables: OrdersQueryVariables) => ['orders.infinite', variables];

export const OrdersUnfulfilledDesyncShopifyDocument = `
    query ordersUnfulfilledDesyncShopify($saleId: ID!, $input: OrdersInput!) {
  orders(saleId: $saleId, input: $input) {
    nodes {
      integration {
        errorMessage
      }
    }
    totalCount
    paging {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
      pageSize
    }
  }
}
    `;

export const useOrdersUnfulfilledDesyncShopifyQuery = <
      TData = OrdersUnfulfilledDesyncShopifyQuery,
      TError = unknown
    >(
      variables: OrdersUnfulfilledDesyncShopifyQueryVariables,
      options?: Omit<UseQueryOptions<OrdersUnfulfilledDesyncShopifyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrdersUnfulfilledDesyncShopifyQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrdersUnfulfilledDesyncShopifyQuery, TError, TData>(
      {
    queryKey: ['ordersUnfulfilledDesyncShopify', variables],
    queryFn: useFetchData<OrdersUnfulfilledDesyncShopifyQuery, OrdersUnfulfilledDesyncShopifyQueryVariables>(OrdersUnfulfilledDesyncShopifyDocument).bind(null, variables),
    ...options
  }
    )};

useOrdersUnfulfilledDesyncShopifyQuery.getKey = (variables: OrdersUnfulfilledDesyncShopifyQueryVariables) => ['ordersUnfulfilledDesyncShopify', variables];

export const useInfiniteOrdersUnfulfilledDesyncShopifyQuery = <
      TData = InfiniteData<OrdersUnfulfilledDesyncShopifyQuery>,
      TError = unknown
    >(
      variables: OrdersUnfulfilledDesyncShopifyQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrdersUnfulfilledDesyncShopifyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrdersUnfulfilledDesyncShopifyQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrdersUnfulfilledDesyncShopifyQuery, OrdersUnfulfilledDesyncShopifyQueryVariables>(OrdersUnfulfilledDesyncShopifyDocument)
    return useInfiniteQuery<OrdersUnfulfilledDesyncShopifyQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ordersUnfulfilledDesyncShopify.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrdersUnfulfilledDesyncShopifyQuery.getKey = (variables: OrdersUnfulfilledDesyncShopifyQueryVariables) => ['ordersUnfulfilledDesyncShopify.infinite', variables];

export const OrdersCountersDocument = `
    query ordersCounters($sellerId: ID!, $saleId: ID!) {
  ordersCounters(sellerId: $sellerId, saleId: $saleId) {
    tagging {
      brand {
        actionRequiredUnfulfilled
        actionRequiredShipmentIncident
        actionRequiredClaim
        actionRequiredReturn
        actionRequired
        available
      }
      type {
        digital
        physical
      }
      status {
        canceled
        pendingValidation
        validated
      }
      shopify {
        none
        unsynchronized
        synchronized
      }
      shippingMode {
        none
        pickupPoint
        home
      }
      fulfillment {
        unfulfilled
        fulfilled
      }
      shipment {
        none
        pending
        infoReceived
        inTransit
        outForDelivery
        attemptFail
        availableForPickup
        delivered
        exception
        expired
      }
      claim {
        none
        opened
        closed
      }
      claimReason {
        none
        deliveredButDamaged
        deliveredButIncomplete
        deliveredButWrong
        notDeliveredAndReturnedToSender
        notDeliveredAndTrackingBlocked
        notDeliveredAndTrackingDelivered
        voucherNotWorking
        other
      }
      refund {
        none
        partiallyRefunded
        totallyRefunded
      }
      reship {
        none
        reshipped
      }
      return {
        none
        canceled
        requested
        inProgress
        delivered
        validated
      }
    }
  }
}
    `;

export const useOrdersCountersQuery = <
      TData = OrdersCountersQuery,
      TError = unknown
    >(
      variables: OrdersCountersQueryVariables,
      options?: Omit<UseQueryOptions<OrdersCountersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrdersCountersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrdersCountersQuery, TError, TData>(
      {
    queryKey: ['ordersCounters', variables],
    queryFn: useFetchData<OrdersCountersQuery, OrdersCountersQueryVariables>(OrdersCountersDocument).bind(null, variables),
    ...options
  }
    )};

useOrdersCountersQuery.getKey = (variables: OrdersCountersQueryVariables) => ['ordersCounters', variables];

export const useInfiniteOrdersCountersQuery = <
      TData = InfiniteData<OrdersCountersQuery>,
      TError = unknown
    >(
      variables: OrdersCountersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrdersCountersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrdersCountersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrdersCountersQuery, OrdersCountersQueryVariables>(OrdersCountersDocument)
    return useInfiniteQuery<OrdersCountersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ordersCounters.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrdersCountersQuery.getKey = (variables: OrdersCountersQueryVariables) => ['ordersCounters.infinite', variables];

export const OrdersExportDocument = `
    query ordersExport($sellerId: ID!, $saleId: ID!, $input: OrdersExportInput!) {
  ordersExport(sellerId: $sellerId, saleId: $saleId, input: $input) {
    fileUrl
  }
}
    `;

export const useOrdersExportQuery = <
      TData = OrdersExportQuery,
      TError = unknown
    >(
      variables: OrdersExportQueryVariables,
      options?: Omit<UseQueryOptions<OrdersExportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrdersExportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrdersExportQuery, TError, TData>(
      {
    queryKey: ['ordersExport', variables],
    queryFn: useFetchData<OrdersExportQuery, OrdersExportQueryVariables>(OrdersExportDocument).bind(null, variables),
    ...options
  }
    )};

useOrdersExportQuery.getKey = (variables: OrdersExportQueryVariables) => ['ordersExport', variables];

export const useInfiniteOrdersExportQuery = <
      TData = InfiniteData<OrdersExportQuery>,
      TError = unknown
    >(
      variables: OrdersExportQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrdersExportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrdersExportQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrdersExportQuery, OrdersExportQueryVariables>(OrdersExportDocument)
    return useInfiniteQuery<OrdersExportQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ordersExport.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrdersExportQuery.getKey = (variables: OrdersExportQueryVariables) => ['ordersExport.infinite', variables];

export const OrdersUnfulfilledExportDocument = `
    query ordersUnfulfilledExport($sellerId: ID!, $saleId: ID!, $input: OrdersUnfulfilledExportInput!) {
  ordersUnfulfilledExport(sellerId: $sellerId, saleId: $saleId, input: $input) {
    fileUrl
  }
}
    `;

export const useOrdersUnfulfilledExportQuery = <
      TData = OrdersUnfulfilledExportQuery,
      TError = unknown
    >(
      variables: OrdersUnfulfilledExportQueryVariables,
      options?: Omit<UseQueryOptions<OrdersUnfulfilledExportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<OrdersUnfulfilledExportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<OrdersUnfulfilledExportQuery, TError, TData>(
      {
    queryKey: ['ordersUnfulfilledExport', variables],
    queryFn: useFetchData<OrdersUnfulfilledExportQuery, OrdersUnfulfilledExportQueryVariables>(OrdersUnfulfilledExportDocument).bind(null, variables),
    ...options
  }
    )};

useOrdersUnfulfilledExportQuery.getKey = (variables: OrdersUnfulfilledExportQueryVariables) => ['ordersUnfulfilledExport', variables];

export const useInfiniteOrdersUnfulfilledExportQuery = <
      TData = InfiniteData<OrdersUnfulfilledExportQuery>,
      TError = unknown
    >(
      variables: OrdersUnfulfilledExportQueryVariables,
      options: Omit<UseInfiniteQueryOptions<OrdersUnfulfilledExportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<OrdersUnfulfilledExportQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<OrdersUnfulfilledExportQuery, OrdersUnfulfilledExportQueryVariables>(OrdersUnfulfilledExportDocument)
    return useInfiniteQuery<OrdersUnfulfilledExportQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ordersUnfulfilledExport.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteOrdersUnfulfilledExportQuery.getKey = (variables: OrdersUnfulfilledExportQueryVariables) => ['ordersUnfulfilledExport.infinite', variables];

export const StocksExportDocument = `
    query stocksExport($saleId: ID!, $input: StocksExportInput!) {
  stocksExport(saleId: $saleId, input: $input) {
    fileUrl
  }
}
    `;

export const useStocksExportQuery = <
      TData = StocksExportQuery,
      TError = unknown
    >(
      variables: StocksExportQueryVariables,
      options?: Omit<UseQueryOptions<StocksExportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<StocksExportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<StocksExportQuery, TError, TData>(
      {
    queryKey: ['stocksExport', variables],
    queryFn: useFetchData<StocksExportQuery, StocksExportQueryVariables>(StocksExportDocument).bind(null, variables),
    ...options
  }
    )};

useStocksExportQuery.getKey = (variables: StocksExportQueryVariables) => ['stocksExport', variables];

export const useInfiniteStocksExportQuery = <
      TData = InfiniteData<StocksExportQuery>,
      TError = unknown
    >(
      variables: StocksExportQueryVariables,
      options: Omit<UseInfiniteQueryOptions<StocksExportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<StocksExportQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<StocksExportQuery, StocksExportQueryVariables>(StocksExportDocument)
    return useInfiniteQuery<StocksExportQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['stocksExport.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteStocksExportQuery.getKey = (variables: StocksExportQueryVariables) => ['stocksExport.infinite', variables];

export const SupplierBillingAdjustmentDocument = `
    query supplierBillingAdjustment($supplierBillingAdjustmentId: ID!, $withNotes: Boolean!) {
  supplierBillingAdjustment(
    supplierBillingAdjustmentId: $supplierBillingAdjustmentId
  ) {
    ... on SupplierBillingAdjustmentDraft {
      __typename
      draftAmountVatExcludedInCents: amountVatExcludedInCents
      draftAmountVatIncludedInCents: amountVatIncludedInCents
      chargedTo
      createdAt
      createdBy {
        userId
        firstname
        lastname
        picture
      }
      deletedAt
      draftDescription: description
      documents
      notes @include(if: $withNotes) {
        content
        createdAt
        createdBy {
          userId
          firstname
          lastname
          picture
        }
        createdById
        id
        supplierBillingAdjustmentId
      }
      supplierBillingAdjustmentId
      draftTitle: title
      updatedAt
      draftVatRate: vatRate
    }
    ... on SupplierBillingAdjustmentValidated {
      __typename
      amountVatExcludedInCents
      amountVatIncludedInCents
      chargedTo
      createdAt
      createdBy {
        userId
        firstname
        lastname
      }
      deletedAt
      description
      documents
      notes @include(if: $withNotes) {
        content
        createdAt
        createdBy {
          userId
          firstname
          lastname
          picture
        }
        createdById
        id
        supplierBillingAdjustmentId
      }
      supplierBillingAdjustmentId
      title
      updatedAt
      validatedAt
      validatedBy {
        userId
        firstname
        lastname
      }
      vatRate
    }
  }
}
    `;

export const useSupplierBillingAdjustmentQuery = <
      TData = SupplierBillingAdjustmentQuery,
      TError = unknown
    >(
      variables: SupplierBillingAdjustmentQueryVariables,
      options?: Omit<UseQueryOptions<SupplierBillingAdjustmentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SupplierBillingAdjustmentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SupplierBillingAdjustmentQuery, TError, TData>(
      {
    queryKey: ['supplierBillingAdjustment', variables],
    queryFn: useFetchData<SupplierBillingAdjustmentQuery, SupplierBillingAdjustmentQueryVariables>(SupplierBillingAdjustmentDocument).bind(null, variables),
    ...options
  }
    )};

useSupplierBillingAdjustmentQuery.getKey = (variables: SupplierBillingAdjustmentQueryVariables) => ['supplierBillingAdjustment', variables];

export const useInfiniteSupplierBillingAdjustmentQuery = <
      TData = InfiniteData<SupplierBillingAdjustmentQuery>,
      TError = unknown
    >(
      variables: SupplierBillingAdjustmentQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SupplierBillingAdjustmentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SupplierBillingAdjustmentQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SupplierBillingAdjustmentQuery, SupplierBillingAdjustmentQueryVariables>(SupplierBillingAdjustmentDocument)
    return useInfiniteQuery<SupplierBillingAdjustmentQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['supplierBillingAdjustment.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSupplierBillingAdjustmentQuery.getKey = (variables: SupplierBillingAdjustmentQueryVariables) => ['supplierBillingAdjustment.infinite', variables];

export const SupplierBillingAdjustmentsDocument = `
    query supplierBillingAdjustments($saleId: ID!) {
  supplierBillingAdjustments(saleId: $saleId) {
    ...PartialSupplierBillingAdjustment
  }
}
    ${PartialSupplierBillingAdjustmentFragmentDoc}`;

export const useSupplierBillingAdjustmentsQuery = <
      TData = SupplierBillingAdjustmentsQuery,
      TError = unknown
    >(
      variables: SupplierBillingAdjustmentsQueryVariables,
      options?: Omit<UseQueryOptions<SupplierBillingAdjustmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SupplierBillingAdjustmentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SupplierBillingAdjustmentsQuery, TError, TData>(
      {
    queryKey: ['supplierBillingAdjustments', variables],
    queryFn: useFetchData<SupplierBillingAdjustmentsQuery, SupplierBillingAdjustmentsQueryVariables>(SupplierBillingAdjustmentsDocument).bind(null, variables),
    ...options
  }
    )};

useSupplierBillingAdjustmentsQuery.getKey = (variables: SupplierBillingAdjustmentsQueryVariables) => ['supplierBillingAdjustments', variables];

export const useInfiniteSupplierBillingAdjustmentsQuery = <
      TData = InfiniteData<SupplierBillingAdjustmentsQuery>,
      TError = unknown
    >(
      variables: SupplierBillingAdjustmentsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SupplierBillingAdjustmentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SupplierBillingAdjustmentsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<SupplierBillingAdjustmentsQuery, SupplierBillingAdjustmentsQueryVariables>(SupplierBillingAdjustmentsDocument)
    return useInfiniteQuery<SupplierBillingAdjustmentsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['supplierBillingAdjustments.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSupplierBillingAdjustmentsQuery.getKey = (variables: SupplierBillingAdjustmentsQueryVariables) => ['supplierBillingAdjustments.infinite', variables];

export const UsedCouriersDocument = `
    query usedCouriers {
  usedCouriers {
    ...PartialCourier
    supportedCountries
  }
}
    ${PartialCourierFragmentDoc}`;

export const useUsedCouriersQuery = <
      TData = UsedCouriersQuery,
      TError = unknown
    >(
      variables?: UsedCouriersQueryVariables,
      options?: Omit<UseQueryOptions<UsedCouriersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UsedCouriersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UsedCouriersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['usedCouriers'] : ['usedCouriers', variables],
    queryFn: useFetchData<UsedCouriersQuery, UsedCouriersQueryVariables>(UsedCouriersDocument).bind(null, variables),
    ...options
  }
    )};

useUsedCouriersQuery.getKey = (variables?: UsedCouriersQueryVariables) => variables === undefined ? ['usedCouriers'] : ['usedCouriers', variables];

export const useInfiniteUsedCouriersQuery = <
      TData = InfiniteData<UsedCouriersQuery>,
      TError = unknown
    >(
      variables: UsedCouriersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UsedCouriersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UsedCouriersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useFetchData<UsedCouriersQuery, UsedCouriersQueryVariables>(UsedCouriersDocument)
    return useInfiniteQuery<UsedCouriersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['usedCouriers.infinite'] : ['usedCouriers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteUsedCouriersQuery.getKey = (variables?: UsedCouriersQueryVariables) => variables === undefined ? ['usedCouriers.infinite'] : ['usedCouriers.infinite', variables];

export const AcceptOrderClaimWithRefundDocument = `
    mutation acceptOrderClaimWithRefund($input: AcceptOrderClaimWithRefundInput!) {
  acceptOrderClaimWithRefund(input: $input)
}
    `;

export const useAcceptOrderClaimWithRefundMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptOrderClaimWithRefundMutation, TError, AcceptOrderClaimWithRefundMutationVariables, TContext>) => {
    
    return useMutation<AcceptOrderClaimWithRefundMutation, TError, AcceptOrderClaimWithRefundMutationVariables, TContext>(
      {
    mutationKey: ['acceptOrderClaimWithRefund'],
    mutationFn: useFetchData<AcceptOrderClaimWithRefundMutation, AcceptOrderClaimWithRefundMutationVariables>(AcceptOrderClaimWithRefundDocument),
    ...options
  }
    )};

export const AcceptOrderClaimWithReshipDocument = `
    mutation acceptOrderClaimWithReship($input: AcceptOrderClaimWithReshipInput!) {
  acceptOrderClaimWithReship(input: $input)
}
    `;

export const useAcceptOrderClaimWithReshipMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptOrderClaimWithReshipMutation, TError, AcceptOrderClaimWithReshipMutationVariables, TContext>) => {
    
    return useMutation<AcceptOrderClaimWithReshipMutation, TError, AcceptOrderClaimWithReshipMutationVariables, TContext>(
      {
    mutationKey: ['acceptOrderClaimWithReship'],
    mutationFn: useFetchData<AcceptOrderClaimWithReshipMutation, AcceptOrderClaimWithReshipMutationVariables>(AcceptOrderClaimWithReshipDocument),
    ...options
  }
    )};

export const AcceptOrderClaimWithVoucherReplacementCodesDocument = `
    mutation acceptOrderClaimWithVoucherReplacementCodes($input: AcceptOrderClaimWithVoucherReplacementCodesInput!) {
  acceptOrderClaimWithVoucherReplacementCodes(input: $input)
}
    `;

export const useAcceptOrderClaimWithVoucherReplacementCodesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptOrderClaimWithVoucherReplacementCodesMutation, TError, AcceptOrderClaimWithVoucherReplacementCodesMutationVariables, TContext>) => {
    
    return useMutation<AcceptOrderClaimWithVoucherReplacementCodesMutation, TError, AcceptOrderClaimWithVoucherReplacementCodesMutationVariables, TContext>(
      {
    mutationKey: ['acceptOrderClaimWithVoucherReplacementCodes'],
    mutationFn: useFetchData<AcceptOrderClaimWithVoucherReplacementCodesMutation, AcceptOrderClaimWithVoucherReplacementCodesMutationVariables>(AcceptOrderClaimWithVoucherReplacementCodesDocument),
    ...options
  }
    )};

export const AcceptOrderClaimWithVoucherReplacementMessageDocument = `
    mutation acceptOrderClaimWithVoucherReplacementMessage($input: AcceptOrderClaimWithVoucherReplacementMessageInput!) {
  acceptOrderClaimWithVoucherReplacementMessage(input: $input)
}
    `;

export const useAcceptOrderClaimWithVoucherReplacementMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AcceptOrderClaimWithVoucherReplacementMessageMutation, TError, AcceptOrderClaimWithVoucherReplacementMessageMutationVariables, TContext>) => {
    
    return useMutation<AcceptOrderClaimWithVoucherReplacementMessageMutation, TError, AcceptOrderClaimWithVoucherReplacementMessageMutationVariables, TContext>(
      {
    mutationKey: ['acceptOrderClaimWithVoucherReplacementMessage'],
    mutationFn: useFetchData<AcceptOrderClaimWithVoucherReplacementMessageMutation, AcceptOrderClaimWithVoucherReplacementMessageMutationVariables>(AcceptOrderClaimWithVoucherReplacementMessageDocument),
    ...options
  }
    )};

export const ChangePasswordDocument = `
    mutation changePassword($newPassword: String!) {
  changePassword(newPassword: $newPassword)
}
    `;

export const useChangePasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangePasswordMutation, TError, ChangePasswordMutationVariables, TContext>) => {
    
    return useMutation<ChangePasswordMutation, TError, ChangePasswordMutationVariables, TContext>(
      {
    mutationKey: ['changePassword'],
    mutationFn: useFetchData<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument),
    ...options
  }
    )};

export const CreateOrderParcelDocument = `
    mutation createOrderParcel($input: CreateOrderParcelInput!) {
  createOrderParcel(input: $input)
}
    `;

export const useCreateOrderParcelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateOrderParcelMutation, TError, CreateOrderParcelMutationVariables, TContext>) => {
    
    return useMutation<CreateOrderParcelMutation, TError, CreateOrderParcelMutationVariables, TContext>(
      {
    mutationKey: ['createOrderParcel'],
    mutationFn: useFetchData<CreateOrderParcelMutation, CreateOrderParcelMutationVariables>(CreateOrderParcelDocument),
    ...options
  }
    )};

export const CreateSupplierBillingAdjustmentDocument = `
    mutation createSupplierBillingAdjustment($input: CreateSupplierBillingAdjustmentInput!) {
  createSupplierBillingAdjustment(input: $input)
}
    `;

export const useCreateSupplierBillingAdjustmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSupplierBillingAdjustmentMutation, TError, CreateSupplierBillingAdjustmentMutationVariables, TContext>) => {
    
    return useMutation<CreateSupplierBillingAdjustmentMutation, TError, CreateSupplierBillingAdjustmentMutationVariables, TContext>(
      {
    mutationKey: ['createSupplierBillingAdjustment'],
    mutationFn: useFetchData<CreateSupplierBillingAdjustmentMutation, CreateSupplierBillingAdjustmentMutationVariables>(CreateSupplierBillingAdjustmentDocument),
    ...options
  }
    )};

export const CreateSupplierBillingAdjustmentNoteDocument = `
    mutation createSupplierBillingAdjustmentNote($supplierBillingAdjustmentId: ID!, $content: String!) {
  createSupplierBillingAdjustmentNote(
    supplierBillingAdjustmentId: $supplierBillingAdjustmentId
    content: $content
  )
}
    `;

export const useCreateSupplierBillingAdjustmentNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateSupplierBillingAdjustmentNoteMutation, TError, CreateSupplierBillingAdjustmentNoteMutationVariables, TContext>) => {
    
    return useMutation<CreateSupplierBillingAdjustmentNoteMutation, TError, CreateSupplierBillingAdjustmentNoteMutationVariables, TContext>(
      {
    mutationKey: ['createSupplierBillingAdjustmentNote'],
    mutationFn: useFetchData<CreateSupplierBillingAdjustmentNoteMutation, CreateSupplierBillingAdjustmentNoteMutationVariables>(CreateSupplierBillingAdjustmentNoteDocument),
    ...options
  }
    )};

export const CreatePasswordConnectionDocument = `
    mutation createPasswordConnection($userInfo: UserPasswordConnection!) {
  createPasswordConnection(userInfo: $userInfo)
}
    `;

export const useCreatePasswordConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePasswordConnectionMutation, TError, CreatePasswordConnectionMutationVariables, TContext>) => {
    
    return useMutation<CreatePasswordConnectionMutation, TError, CreatePasswordConnectionMutationVariables, TContext>(
      {
    mutationKey: ['createPasswordConnection'],
    mutationFn: useFetchData<CreatePasswordConnectionMutation, CreatePasswordConnectionMutationVariables>(CreatePasswordConnectionDocument),
    ...options
  }
    )};

export const DeleteSupplierBillingAdjustmentDocument = `
    mutation deleteSupplierBillingAdjustment($supplierBillingAdjustmentId: ID!) {
  deleteSupplierBillingAdjustment(
    supplierBillingAdjustmentId: $supplierBillingAdjustmentId
  )
}
    `;

export const useDeleteSupplierBillingAdjustmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSupplierBillingAdjustmentMutation, TError, DeleteSupplierBillingAdjustmentMutationVariables, TContext>) => {
    
    return useMutation<DeleteSupplierBillingAdjustmentMutation, TError, DeleteSupplierBillingAdjustmentMutationVariables, TContext>(
      {
    mutationKey: ['deleteSupplierBillingAdjustment'],
    mutationFn: useFetchData<DeleteSupplierBillingAdjustmentMutation, DeleteSupplierBillingAdjustmentMutationVariables>(DeleteSupplierBillingAdjustmentDocument),
    ...options
  }
    )};

export const DeleteSupplierBillingAdjustmentNoteDocument = `
    mutation deleteSupplierBillingAdjustmentNote($supplierBillingAdjustmentNoteId: ID!) {
  deleteSupplierBillingAdjustmentNote(
    supplierBillingAdjustmentNoteId: $supplierBillingAdjustmentNoteId
  )
}
    `;

export const useDeleteSupplierBillingAdjustmentNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteSupplierBillingAdjustmentNoteMutation, TError, DeleteSupplierBillingAdjustmentNoteMutationVariables, TContext>) => {
    
    return useMutation<DeleteSupplierBillingAdjustmentNoteMutation, TError, DeleteSupplierBillingAdjustmentNoteMutationVariables, TContext>(
      {
    mutationKey: ['deleteSupplierBillingAdjustmentNote'],
    mutationFn: useFetchData<DeleteSupplierBillingAdjustmentNoteMutation, DeleteSupplierBillingAdjustmentNoteMutationVariables>(DeleteSupplierBillingAdjustmentNoteDocument),
    ...options
  }
    )};

export const DetachBrandUserDocument = `
    mutation detachBrandUser($userId: String!) {
  detachBrandUser(userId: $userId)
}
    `;

export const useDetachBrandUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DetachBrandUserMutation, TError, DetachBrandUserMutationVariables, TContext>) => {
    
    return useMutation<DetachBrandUserMutation, TError, DetachBrandUserMutationVariables, TContext>(
      {
    mutationKey: ['detachBrandUser'],
    mutationFn: useFetchData<DetachBrandUserMutation, DetachBrandUserMutationVariables>(DetachBrandUserDocument),
    ...options
  }
    )};

export const EditBasicUserInfoDocument = `
    mutation editBasicUserInfo($basicUserInfo: BasicUserInfo!) {
  editBasicUserInfo(basicUserInfo: $basicUserInfo)
}
    `;

export const useEditBasicUserInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditBasicUserInfoMutation, TError, EditBasicUserInfoMutationVariables, TContext>) => {
    
    return useMutation<EditBasicUserInfoMutation, TError, EditBasicUserInfoMutationVariables, TContext>(
      {
    mutationKey: ['editBasicUserInfo'],
    mutationFn: useFetchData<EditBasicUserInfoMutation, EditBasicUserInfoMutationVariables>(EditBasicUserInfoDocument),
    ...options
  }
    )};

export const GenerateInvoiceUploadUrlDocument = `
    mutation generateInvoiceUploadUrl($saleId: ID!, $upload: UploadInput!) {
  generateInvoiceUploadUrl(saleId: $saleId, upload: $upload) {
    expiresAt
    key
    url
  }
}
    `;

export const useGenerateInvoiceUploadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateInvoiceUploadUrlMutation, TError, GenerateInvoiceUploadUrlMutationVariables, TContext>) => {
    
    return useMutation<GenerateInvoiceUploadUrlMutation, TError, GenerateInvoiceUploadUrlMutationVariables, TContext>(
      {
    mutationKey: ['generateInvoiceUploadUrl'],
    mutationFn: useFetchData<GenerateInvoiceUploadUrlMutation, GenerateInvoiceUploadUrlMutationVariables>(GenerateInvoiceUploadUrlDocument),
    ...options
  }
    )};

export const GenerateProfilePictureUploadUrlDocument = `
    mutation generateProfilePictureUploadUrl($upload: UploadInput!) {
  generateProfilePictureUploadUrl(upload: $upload) {
    expiresAt
    key
    url
  }
}
    `;

export const useGenerateProfilePictureUploadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateProfilePictureUploadUrlMutation, TError, GenerateProfilePictureUploadUrlMutationVariables, TContext>) => {
    
    return useMutation<GenerateProfilePictureUploadUrlMutation, TError, GenerateProfilePictureUploadUrlMutationVariables, TContext>(
      {
    mutationKey: ['generateProfilePictureUploadUrl'],
    mutationFn: useFetchData<GenerateProfilePictureUploadUrlMutation, GenerateProfilePictureUploadUrlMutationVariables>(GenerateProfilePictureUploadUrlDocument),
    ...options
  }
    )};

export const GenerateSupplierBillingAdjusmentDocumentUploadUrlDocument = `
    mutation generateSupplierBillingAdjusmentDocumentUploadUrl($saleId: ID!, $upload: UploadInput!) {
  generateSupplierBillingAdjusmentDocumentUploadUrl(
    saleId: $saleId
    upload: $upload
  ) {
    expiresAt
    key
    url
  }
}
    `;

export const useGenerateSupplierBillingAdjusmentDocumentUploadUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateSupplierBillingAdjusmentDocumentUploadUrlMutation, TError, GenerateSupplierBillingAdjusmentDocumentUploadUrlMutationVariables, TContext>) => {
    
    return useMutation<GenerateSupplierBillingAdjusmentDocumentUploadUrlMutation, TError, GenerateSupplierBillingAdjusmentDocumentUploadUrlMutationVariables, TContext>(
      {
    mutationKey: ['generateSupplierBillingAdjusmentDocumentUploadUrl'],
    mutationFn: useFetchData<GenerateSupplierBillingAdjusmentDocumentUploadUrlMutation, GenerateSupplierBillingAdjusmentDocumentUploadUrlMutationVariables>(GenerateSupplierBillingAdjusmentDocumentUploadUrlDocument),
    ...options
  }
    )};

export const GroupOrderParcelDocument = `
    mutation groupOrderParcel($input: GroupOrderParcelInput!) {
  groupOrderParcel(input: $input)
}
    `;

export const useGroupOrderParcelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GroupOrderParcelMutation, TError, GroupOrderParcelMutationVariables, TContext>) => {
    
    return useMutation<GroupOrderParcelMutation, TError, GroupOrderParcelMutationVariables, TContext>(
      {
    mutationKey: ['groupOrderParcel'],
    mutationFn: useFetchData<GroupOrderParcelMutation, GroupOrderParcelMutationVariables>(GroupOrderParcelDocument),
    ...options
  }
    )};

export const GenerateInvoiceCustomsDocument = `
    mutation generateInvoiceCustoms($orderId: ID!) {
  generateInvoiceCustoms(orderId: $orderId) {
    url
  }
}
    `;

export const useGenerateInvoiceCustomsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateInvoiceCustomsMutation, TError, GenerateInvoiceCustomsMutationVariables, TContext>) => {
    
    return useMutation<GenerateInvoiceCustomsMutation, TError, GenerateInvoiceCustomsMutationVariables, TContext>(
      {
    mutationKey: ['generateInvoiceCustoms'],
    mutationFn: useFetchData<GenerateInvoiceCustomsMutation, GenerateInvoiceCustomsMutationVariables>(GenerateInvoiceCustomsDocument),
    ...options
  }
    )};

export const GeneratePurchaseOrderDocument = `
    mutation generatePurchaseOrder($orderId: ID!) {
  generatePurchaseOrder(orderId: $orderId) {
    url
  }
}
    `;

export const useGeneratePurchaseOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GeneratePurchaseOrderMutation, TError, GeneratePurchaseOrderMutationVariables, TContext>) => {
    
    return useMutation<GeneratePurchaseOrderMutation, TError, GeneratePurchaseOrderMutationVariables, TContext>(
      {
    mutationKey: ['generatePurchaseOrder'],
    mutationFn: useFetchData<GeneratePurchaseOrderMutation, GeneratePurchaseOrderMutationVariables>(GeneratePurchaseOrderDocument),
    ...options
  }
    )};

export const JoinBrandDocument = `
    mutation joinBrand($brandId: String!, $inviteCode: String!) {
  joinBrand(brandId: $brandId, inviteCode: $inviteCode)
}
    `;

export const useJoinBrandMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<JoinBrandMutation, TError, JoinBrandMutationVariables, TContext>) => {
    
    return useMutation<JoinBrandMutation, TError, JoinBrandMutationVariables, TContext>(
      {
    mutationKey: ['joinBrand'],
    mutationFn: useFetchData<JoinBrandMutation, JoinBrandMutationVariables>(JoinBrandDocument),
    ...options
  }
    )};

export const PostRegisterDocument = `
    mutation postRegister($config: PostRegisterConfig!) {
  postRegister(config: $config)
}
    `;

export const usePostRegisterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<PostRegisterMutation, TError, PostRegisterMutationVariables, TContext>) => {
    
    return useMutation<PostRegisterMutation, TError, PostRegisterMutationVariables, TContext>(
      {
    mutationKey: ['postRegister'],
    mutationFn: useFetchData<PostRegisterMutation, PostRegisterMutationVariables>(PostRegisterDocument),
    ...options
  }
    )};

export const SetStockDocument = `
    mutation setStock($input: SetStockInput!) {
  setStock(input: $input)
}
    `;

export const useSetStockMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetStockMutation, TError, SetStockMutationVariables, TContext>) => {
    
    return useMutation<SetStockMutation, TError, SetStockMutationVariables, TContext>(
      {
    mutationKey: ['setStock'],
    mutationFn: useFetchData<SetStockMutation, SetStockMutationVariables>(SetStockDocument),
    ...options
  }
    )};

export const SetUserRoleDocument = `
    mutation setUserRole($userId: ID!, $role: BrandRole!) {
  setUserRole(userId: $userId, role: $role)
}
    `;

export const useSetUserRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetUserRoleMutation, TError, SetUserRoleMutationVariables, TContext>) => {
    
    return useMutation<SetUserRoleMutation, TError, SetUserRoleMutationVariables, TContext>(
      {
    mutationKey: ['setUserRole'],
    mutationFn: useFetchData<SetUserRoleMutation, SetUserRoleMutationVariables>(SetUserRoleDocument),
    ...options
  }
    )};

export const SubmitDownPaymentDocument = `
    mutation submitDownPayment($input: SubmitDownPaymentInput!, $saleId: ID!) {
  submitDownPayment(input: $input, saleId: $saleId)
}
    `;

export const useSubmitDownPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitDownPaymentMutation, TError, SubmitDownPaymentMutationVariables, TContext>) => {
    
    return useMutation<SubmitDownPaymentMutation, TError, SubmitDownPaymentMutationVariables, TContext>(
      {
    mutationKey: ['submitDownPayment'],
    mutationFn: useFetchData<SubmitDownPaymentMutation, SubmitDownPaymentMutationVariables>(SubmitDownPaymentDocument),
    ...options
  }
    )};

export const SubmitInvoiceDocument = `
    mutation submitInvoice($input: SubmitInvoiceInput!, $saleId: ID!) {
  submitInvoice(input: $input, saleId: $saleId)
}
    `;

export const useSubmitInvoiceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitInvoiceMutation, TError, SubmitInvoiceMutationVariables, TContext>) => {
    
    return useMutation<SubmitInvoiceMutation, TError, SubmitInvoiceMutationVariables, TContext>(
      {
    mutationKey: ['submitInvoice'],
    mutationFn: useFetchData<SubmitInvoiceMutation, SubmitInvoiceMutationVariables>(SubmitInvoiceDocument),
    ...options
  }
    )};

export const SwapOrderParcelDocument = `
    mutation swapOrderParcel($input: SwapOrderParcelInput!) {
  swapOrderParcel(input: $input)
}
    `;

export const useSwapOrderParcelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SwapOrderParcelMutation, TError, SwapOrderParcelMutationVariables, TContext>) => {
    
    return useMutation<SwapOrderParcelMutation, TError, SwapOrderParcelMutationVariables, TContext>(
      {
    mutationKey: ['swapOrderParcel'],
    mutationFn: useFetchData<SwapOrderParcelMutation, SwapOrderParcelMutationVariables>(SwapOrderParcelDocument),
    ...options
  }
    )};

export const ValidateSupplierBillingAdjustmentDocument = `
    mutation validateSupplierBillingAdjustment($supplierBillingAdjustmentId: ID!) {
  validateSupplierBillingAdjustment(
    supplierBillingAdjustmentId: $supplierBillingAdjustmentId
  )
}
    `;

export const useValidateSupplierBillingAdjustmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ValidateSupplierBillingAdjustmentMutation, TError, ValidateSupplierBillingAdjustmentMutationVariables, TContext>) => {
    
    return useMutation<ValidateSupplierBillingAdjustmentMutation, TError, ValidateSupplierBillingAdjustmentMutationVariables, TContext>(
      {
    mutationKey: ['validateSupplierBillingAdjustment'],
    mutationFn: useFetchData<ValidateSupplierBillingAdjustmentMutation, ValidateSupplierBillingAdjustmentMutationVariables>(ValidateSupplierBillingAdjustmentDocument),
    ...options
  }
    )};

export const UpdateInviteCodeDocument = `
    mutation updateInviteCode {
  updateInviteCode
}
    `;

export const useUpdateInviteCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateInviteCodeMutation, TError, UpdateInviteCodeMutationVariables, TContext>) => {
    
    return useMutation<UpdateInviteCodeMutation, TError, UpdateInviteCodeMutationVariables, TContext>(
      {
    mutationKey: ['updateInviteCode'],
    mutationFn: useFetchData<UpdateInviteCodeMutation, UpdateInviteCodeMutationVariables>(UpdateInviteCodeDocument),
    ...options
  }
    )};

export const UpdateOrderParcelDocument = `
    mutation updateOrderParcel($input: UpdateOrderParcelInput!) {
  updateOrderParcel(input: $input)
}
    `;

export const useUpdateOrderParcelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOrderParcelMutation, TError, UpdateOrderParcelMutationVariables, TContext>) => {
    
    return useMutation<UpdateOrderParcelMutation, TError, UpdateOrderParcelMutationVariables, TContext>(
      {
    mutationKey: ['updateOrderParcel'],
    mutationFn: useFetchData<UpdateOrderParcelMutation, UpdateOrderParcelMutationVariables>(UpdateOrderParcelDocument),
    ...options
  }
    )};

export const UpdateProfilePictureDocument = `
    mutation updateProfilePicture($url: BaseUrl!) {
  updateProfilePicture(url: $url)
}
    `;

export const useUpdateProfilePictureMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProfilePictureMutation, TError, UpdateProfilePictureMutationVariables, TContext>) => {
    
    return useMutation<UpdateProfilePictureMutation, TError, UpdateProfilePictureMutationVariables, TContext>(
      {
    mutationKey: ['updateProfilePicture'],
    mutationFn: useFetchData<UpdateProfilePictureMutation, UpdateProfilePictureMutationVariables>(UpdateProfilePictureDocument),
    ...options
  }
    )};

export const UpdateSupplierBillingAdjustmentDocument = `
    mutation updateSupplierBillingAdjustment($input: UpdateSupplierBillingAdjustmentInput!) {
  updateSupplierBillingAdjustment(input: $input)
}
    `;

export const useUpdateSupplierBillingAdjustmentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSupplierBillingAdjustmentMutation, TError, UpdateSupplierBillingAdjustmentMutationVariables, TContext>) => {
    
    return useMutation<UpdateSupplierBillingAdjustmentMutation, TError, UpdateSupplierBillingAdjustmentMutationVariables, TContext>(
      {
    mutationKey: ['updateSupplierBillingAdjustment'],
    mutationFn: useFetchData<UpdateSupplierBillingAdjustmentMutation, UpdateSupplierBillingAdjustmentMutationVariables>(UpdateSupplierBillingAdjustmentDocument),
    ...options
  }
    )};

export const UpdateUserLanguageDocument = `
    mutation updateUserLanguage($preferredLanguage: String!) {
  updateUserLanguage(preferredLanguage: $preferredLanguage)
}
    `;

export const useUpdateUserLanguageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserLanguageMutation, TError, UpdateUserLanguageMutationVariables, TContext>) => {
    
    return useMutation<UpdateUserLanguageMutation, TError, UpdateUserLanguageMutationVariables, TContext>(
      {
    mutationKey: ['updateUserLanguage'],
    mutationFn: useFetchData<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>(UpdateUserLanguageDocument),
    ...options
  }
    )};

export const ProductsUpdatedDocument = `
    subscription ProductsUpdated($saleId: ID!) {
  productsUpdated(saleId: $saleId) {
    id
    variants {
      id
      stock {
        id
        quantity
      }
      stockAlertsSummary {
        activeAlertsCount
        archivedAlertsCount
        potentialRevenue
      }
    }
  }
}
    `;
export const ShopifyInstalledDocument = `
    subscription shopifyInstalled {
  shopifyInstalled
}
    `;